<template>
<div class="container">
	<div class="page page-products">
		<!-- Header -->
		<div class="page-header">
			<div class="row">
				<div class="col-md-9">
					<h1 class="page-title">{{ $t('Products') }}</h1>
				</div>
				<div class="col-md-3">
					<div class="page-header-right text-right"></div>
				</div>
			</div>
		</div>

		<product-stats :stats="stats"
			:is-show-label="false"
			:clickable="true"
			:status="status"
			:is-fetching="isFetchingStatistic"
			:excluded-boards="['all']"
			@action="overviewAction">
		</product-stats>

		<!-- Table Menu -->
		<div class="table-list-menu d-lg-flex align-items-center">

			<div class="table-actions d-flex align-items-center flex-wrap">

				<!-- Add New Product -->
				<a
					class="btn btn-primary btn-sm"
					href="/admin/products/new"
					target="_blank"
					v-if="isCanAddProduct"
				>
					<i class="material-icons">add</i><span>Add New Product</span>
				</a>

				<!-- Actions -->
				<div class="dropdown">
					<button
						type="button"
						class="btn btn-sm btn-light dropdown-toggle"
						data-toggle="dropdown"
						data-display="static"
						aria-haspopup="true"
						aria-expanded="false"
					>
						Actions
					</button>

					<div class="dropdown-menu table-action-dropdown">
						<!-- Bulk Delete -->
						<button
							class="dropdown-item"
							:class="{ 'is-loading': isDeleting }"
							:disabled="selectedProducts.length === 0"
							@click="isShowDeleteProductBulk = true"
							v-if="isCanDeleteProduct && deleted !== '1'">
							<i class="material-icons text-danger">delete</i>
							<span>{{ $t('Delete') }}</span>
						</button>

					<!-- Bulk Update Handling Fee -->
					<button
						class="dropdown-item"
						:class="{ 'is-loading': isBulkUpdateHandlingFee }"
						:disabled="selectedProducts.length === 0"
						@click="showModalBulkUpdateHandlingFee">
						<i class="material-icons text-success">local_shipping</i>
						<span>{{ $t('Update Handling Fee') }}</span>
					</button>

					<!-- Bulk Update Commission -->
					<button
						class="dropdown-item"
						:disabled="selectedProducts.length === 0"
						@click="isShowBulkCommissionModal = true">
						<i class="material-icons text-primary">percent</i>
						<span>Bulk Commission</span>
					</button>

						<!-- Bulk Update Blacklisted Sellers -->
						<button
							class="dropdown-item"
							:class="{ 'is-loading': isBulkUpdateBlacklistedSellers }"
							:disabled="selectedProducts.length === 0"
							@click="showModalBulkUpdateBlacklistedSellers">
							<i class="material-icons text-danger">block</i>
							<span>{{ $t('Blacklisted Sellers') }}</span>
						</button>

						<!-- Bulk Marketing Kit -->
						<button
							class="dropdown-item"
							:class="{ 'is-loading': isBulkLoading }"
							:disabled="selectedProducts.length === 0"
							@click="isShowModalBulk"
							v-if="nextStatus == 'recontent'">
							<i class="material-icons">article</i>
							<span>{{ $t('Marketing Kit') }}</span>
						</button>

						<!-- Bulk Landing Page -->
						<button
							class="dropdown-item"
							:class="{ 'is-loading': isBulkLoading }"
							:disabled="selectedProducts.length === 0"
							@click="isShowModalBulk"
							v-if="nextStatus == 'landing page'">
							<i class="material-icons">article</i>
							<span>{{ $t('Landing Page') }}</span>
						</button>

						<!-- Bulk Verification -->
						<button
							class="dropdown-item"
							:class="{ 'is-loading': isBulkLoading }"
							:disabled="selectedProducts.length === 0"
							@click="isShowModalBulk"
							v-if="nextStatus == 'verification'">
							<i class="material-icons">checklist</i>
							<span>{{ $t('Verification') }}</span>
						</button>

						<!-- Bulk Restore -->
						<button
							class="dropdown-item"
							:class="{ 'is-loading': isDeleting }"
							:disabled="selectedProducts.length === 0"
							@click="isShowConfirmRestoreBulk = true"
							v-if="deleted === '1'">
							<i class="material-icons">restore</i>
							<span>{{ $t('Restore') }}</span>
						</button>
					</div>
				</div>

				<!-- Bulk Delete -->
				<!-- <button
					class="btn btn-light btn-icon btn-sm btn-icon-danger mr-2"
					:class="{ 'is-loading': isDeleting }"
					:disabled="selectedProducts.length === 0"
					@click="isShowDeleteProductBulk = true"
					v-if="isCanDeleteProduct && deleted !== '1'">
					<i class="material-icons">delete</i>
					<span>{{ $t('Delete') }}</span>
				</button> -->

				<!-- Bulk Marketing Kit -->
				<!-- <button
					class="btn btn-light btn-icon btn-sm btn-icon-danger mr-2"
					:class="{ 'is-loading': isBulkLoading }"
					:disabled="selectedProducts.length === 0"
					@click="isShowModalBulk"
					v-if="nextStatus == 'recontent'">
					<span>{{ $t('Marketing Kit') }}</span>
				</button> -->

				<!-- Bulk Landing Page -->
				<!-- <button
					class="btn btn-light btn-icon btn-sm btn-icon-danger mr-2"
					:class="{ 'is-loading': isBulkLoading }"
					:disabled="selectedProducts.length === 0"
					@click="isShowModalBulk"
					v-if="nextStatus == 'landing page'">
					<span>{{ $t('Landing Page') }}</span>
				</button> -->

				<!-- Bulk Verification -->
				<!-- <button
					class="btn btn-light btn-icon btn-sm btn-icon-danger mr-2"
					:class="{ 'is-loading': isBulkLoading }"
					:disabled="selectedProducts.length === 0"
					@click="isShowModalBulk"
					v-if="nextStatus == 'verification'">
					<span>{{ $t('Verification') }}</span>
				</button> -->

				<!-- Bulk Updated -->
				<!-- <button
					class="btn btn-light btn-icon btn-sm btn-icon-danger mr-2"
					:class="{ 'is-loading': isBulkLoading }"
					:disabled="selectedProducts.length === 0"
					@click="isShowModalBulk"
					v-if="nextStatus === 'updated'">
					<span>{{ $t('Updated') }}</span>
				</button> -->

				<!-- Bulk Active
				<button
					class="btn btn-light btn-icon btn-sm btn-icon-danger mr-2"
					:class="{ 'is-loading': isBulkLoading }"
					:disabled="selectedProducts.length === 0"
					@click="isShowModalBulk"
					v-if="nextStatus === 'live'">
					<span>{{ $t('Active') }}</span>
				</button> -->

				<!-- Bulk Restore -->
				<!-- <button
					class="btn btn-light btn-icon btn-sm btn-icon-danger mr-2"
					:class="{ 'is-loading': isDeleting }"
					:disabled="selectedProducts.length === 0"
					@click="isShowConfirmRestoreBulk = true"
					v-if="deleted === '1'">
					<i class="material-icons">restore</i>
					<span>{{ $t('Restore') }}</span>
				</button> -->

				<!-- Selected Label -->
				<div
					class="btn btn-plain btn-sm d-flex align-items-center disabled"
					v-if="selectedProducts && selectedProducts.length > 0">
					{{ selectedProducts.length }} {{ $t('Selected Products') }}
				</div>
			</div>

			<div class="table-filters text-right d-flex align-items-center ml-a">
				<!-- filter column -->
				<button
					type="button"
					class="btn btn-light btn-sm flex-center"
					@click="isShowCustomColumns = true"
				>
					<i class="material-icons">view_week</i>
					<span>Customize Columns</span>
				</button>
				<!-- Export -->
				<button
					type="button"
					class="btn btn-sm btn-primary"
					:class="{ 'is-loading': isExporting }"
					@click="exportProducts"
					>
					<i class="material-icons">save_alt</i>
					<span class="mr-2">{{ $t('Export') }}</span>
				</button>
				<!-- Clear Filter -->
				<button
					type="button"
					class="btn btn-plain btn-sm"
					@click="clearFilter"
					v-if="isFilterOn"
				>
					{{ $t('Clear Filter') }}
				</button>
				<!-- Filter -->
				<button type="button" class="filter-toggle btn btn-light btn-sm btn-icon" @click="isShowFilter = true">
					<i class="material-icons mr-1">filter_list</i>Filter Product
				</button>
				<!-- Search Keyword -->
				<input type="text" class="input form-control form-control-sm products-search-box" :placeholder="`${$t('Search')}..`" @input="onKeywordChange" v-model="productName">
			</div>
		</div>

		<ul class="nav nav-tabs" v-if="isUserCan('admin_product_action_private_order')">
			<li class="nav-item">
				<a
					class="nav-link"
					:class="{
						'active bg-primary text-white' : saleCategory === 'catalog',
						'bg-white' : saleCategory !== 'catalog',
					}"
					@click="changeSaleCategory('catalog')"
				>
					Catalog
				</a>
			</li>
			<li class="nav-item">
				<a
					class="nav-link"
					:class="{
						'active bg-primary text-white' : saleCategory === 'wholesale',
						'bg-white' : saleCategory !== 'wholesale',
					}"
					@click="changeSaleCategory('wholesale')"
				>
					Wholesale
				</a>
			</li>
		</ul>

		<!-- Main Table -->
		<div class="products-list table-responsive">
			<table class="products-list-table table table-primary table-striped mb-0">
				<thead>
					<tr>
						<th width="5%" class="th-checkbox">
							<label class="input-checkbox-container">
								<input type="checkbox" class="input-checkbox" v-model="selectAll">
								<span></span>
							</label>
						</th>
						<!-- <th width="5%" class="th-sort hidden-sm">
							Product ID
						</th> -->
						<th width="5%">No.</th>
						<th v-if="isShowColumn('product')" width="7%" class="th-product-image text-left">{{ $t('Products') }}</th>
						<th v-if="isShowColumn('product')" class="th-sort text-left" :class="sortClass('name')" @click="changeSorting('name')"></th>
						<!-- <th width="20%" class="th-sort text-left" :class="sortClass('price')" @click="changeSorting('price')">{{ $t('Price') }}</th> -->
						<th v-if="isShowColumn('supplier')" width="15%" class="th-sort text-left">{{ $t('Supplier') }}</th>
						<th v-if="isShowColumn('seller')" width="15%" class="th-sort text-left" :class="sortClass('seller_count')" @click="changeSorting('seller_count')">{{ $t('Seller') }}</th>
						<th v-if="isShowColumn('type')" width="15%" class="th-sort text-left">{{ $t('Type') }}</th>
						<th class="th-sort text-left" v-if="isExpandEnabled && !isSaleCategoryDistributor">
							<div class="d-flex align-items-end">
								<div v-if="isShowColumn('variations')" class="th-sort text-left w-250">{{ $t('Product Variation') }}</div>
								<div v-if="isShowColumn('price')" class="th-sort text-left w-128" :class="sortClass('price')" @click="changeSorting('price')">{{ $t('Price') }}</div>
								<div v-if="isShowColumn('commision')" class="th-sort text-left w-150" :class="sortClass('commission_percentage')" @click="changeSorting('commission_percentage')">
									<div class="label-info">
										<span>{{ $t('Commission') }}</span>
										<span class="info" v-tooltip="'Nilai Komisi akan berefek pada harga coret di katalog'">
											<i class="material-icons">info</i>
										</span>
									</div>
								</div>
								<div v-if="isShowColumn('product_commission')" class="th-sort text-left w-128">{{ $t('Product Commission') }}</div>
								<div v-if="isShowColumn('product_sourcing_fee')" class="th-sort text-left w-200" :class="sortClass('product_sourcing_fee.value')" @click="changeSorting('product_sourcing_fee.value')">{{ $t('Product Sourcing Fee') }}</div>
								<div v-if="isShowColumn('handling_fee')" class="th-sort text-left w-200" :class="sortClass('handling_fee.value')" @click="changeSorting('handling_fee.value')">{{ $t('Handling Fee') }}</div>
								<div v-if="isShowColumn('recommended_price')" class="th-sort text-left w-180">{{ $t('Recommended Price') }}</div>
								<div v-if="isShowColumn('stock')" class="th-sort text-left w-128" :class="sortClass('stock_quantity')" @click="changeSorting('stock_quantity')">{{ $t('Stock') }}</div>
							</div>
						</th>
						<!-- <th v-if="isShowColumn('price')" width="10%" class="th-sort text-left" :class="sortClass('price')" @click="changeSorting('price')">{{ $t('Price') }}</th>
						<th v-if="isShowColumn('commision')" width="8%" class="th-sort text-left" :class="sortClass('commission_percentage')" @click="changeSorting('commission_percentage')">{{ $t('Commission') }}</th>
						<th v-if="isShowColumn('margin')" width="7%" class="th-sort text-left" :class="sortClass('dropship-margin')" @click="changeSorting('dropship.margin')">{{ $t('Margin') }}</th>
						<th v-if="isShowColumn('recommended_price')" width="10%" class="th-sort text-left">{{ $t('Recommended Price') }}</th>
						<th v-if="isShowColumn('stock')" width="10%" class="th-sort text-left">{{ $t('Stock') }}</th> -->
						<th v-if="isShowColumn('visibility') && !isSaleCategoryDistributor" width="7%" class="th-sort text-left" :class="sortClass('visibility')" @click="changeSorting('visibility')">{{ $t('Visibility') }}</th>
						<th v-if="isShowColumn('distributor_status') && isUserCan('admin_product_action_private_order')" class="th-sort text-left w-200" :class="sortClass('distributor_enabled')" @click="changeSorting('distributor_enabled')">{{ $t('Status Wholesale Order') }}</th>
						<th class="th-sort text-left" v-if="isSaleCategoryDistributor">
							<div class="d-flex align-items-end">
								<div v-if="isShowColumn('distributor_price')" class="th-sort text-left w-200" :class="sortClass('distributor_price')" @click="changeSorting('distributor_price')">{{ $t('Wholesale Base Price') }}</div>
								<div v-if="isShowColumn('distributor_slash_price')" class="th-sort text-left w-200" :class="sortClass('distributor_slash_price')" @click="changeSorting('distributor_slash_price')">{{ $t('Wholesale Slash Price') }}</div>
								<div v-if="isShowColumn('distributor_wholesale_price')" class="th-sort text-left w-300" :class="sortClass('distributor_wholesale_price')" @click="changeSorting('distributor_wholesale_price')">{{ $t('Wholesale Price') }}</div>
								<div v-if="isShowColumn('distributor_stock')" class="th-sort text-left w-128" :class="sortClass('distributor_stock')" @click="changeSorting('distributor_stock')">{{ $t('Wholesale Stock') }}</div>
								<div v-if="isShowColumn('distributor_visibility')" class="th-sort text-left w-150" :class="sortClass('distributor_visibility')" @click="changeSorting('distributor_visibility')">{{ $t('Wholesale Visibility') }}</div>
							</div>
						</th>
						<th v-if="isShowColumn('status')" width="7%" class="th-sort text-left" :class="sortClass('status')" @click="changeSorting('status')">{{ $t('Status') }}</th>
						<th v-if="isShowColumn('max_qty')" class="th-sort text-left w-128" :class="sortClass('max_qty.value')" @click="changeSorting('max_qty.value')">{{ $t('Max Qty') }}</th>
						<th v-if="isShowColumn('blacklisted_sellers')" width="7%" class="th-sort text-left w-150" :class="sortClass('blacklisted_sellers_count')" @click="changeSorting('blacklisted_sellers_count')">{{ $t('Blacklisted Sellers') }}</th>
						<th v-if="isShowColumn('changes')" width="10%" class="th-sort text-left">{{ $t('Changes') }}</th>
						<th v-if="isShowColumn('change_history')" width="10%" class="th-sort text-left w-150">{{ $t('Change History') }}</th>
						<th v-if="isShowColumn('created_at')" width="10%" class="th-sort text-left" :class="sortClass('created_at')" @click="changeSorting('created_at')">{{ $t('Created At') }}</th>
						<th v-if="isShowColumn('timestamps')" width="10%" class="th-sort text-left timestamps-date">{{ $t('Timestamps') }}</th>
						<!-- <th width="12%" class="th-sort text-left">{{ $t('Deleted By') }}</th> -->
						<th v-if="isShowColumn('action')" width="8%" class="th-sort text-left">Actions</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(product, index) in products" :key="product._id">
						<td class="align-top">
							<label class="input-checkbox-container">
								<input type="checkbox" class="input-checkbox" :value="product._id" v-model="selectedProducts" :disabled="deleted === 'all' && product.is_deleted">
								<span></span>
							</label>
						</td>
						<!-- <td class="align-middle p-0">
							{{ product._id.$oid ? product._id.$oid : product._id }}
						</td> -->

						<td>{{ index + 1 }}.</td>

						<!-- Product Image -->
						<td v-if="isShowColumn('product')" class="align-top">
							<div
								class="product-image"
								:style="{ backgroundImage: `url(${product.pictures && product.pictures.length > 0 ? product.pictures[0] : 'https://cdn.ostock.id/img/default-product.png'})` }">
							</div>
						</td>
						<!-- Product Name -->
						<td v-if="isShowColumn('product')" class="w-200">
							<div class="product-name">
								<span class="va-m cursor-pointer" @click="showProductDetail(product)">{{ product.name }}</span>
							</div>
							<div>
								<badges
									:is-cod-enabled="checkProductBadge(product, 'cod')"
									:is-lp-enabled="checkProductBadge(product, 'landing_page')"
									:is-marketing-kit-enabled="checkProductBadge(product, 'marketing_kit')"
									:is-private-enabled="checkProductBadge(product, 'private_product')"
									:is-deleted-product="checkProductBadge(product, 'deleted_product')"
									:is-dangerous-goods="checkProductBadge(product, 'dangerous_goods')"
								/>
							</div>
							<!-- <div>
								<small>
									Slug:
									<template v-if="product.slug">
										{{ product.slug }}
									</template>
									<template v-else>-</template>
								</small>
							</div> -->
							<div class="row-actions hidden-sm" v-if="!product.is_deleted">
								<!-- <a @click="showConfirmDuplicateProduct(product)" v-if="isUserCan('product_add')">
									<i class="material-icons md-xs">content_copy</i>
									<span>{{ $t('Duplicate') }}</span>
								</a> -->
								<!-- <router-link :to="{ name: 'productEdit', params: { id: product._id } }" v-if="isUserCan('product_edit')"><i class="material-icons md-xs">edit</i> Edit</router-link> -->
								<div class="d-flex flex-column">
									<div class="d-flex flex-row">
										<a @click="showProductDetail(product)">
											<i class="material-icons md-xs">visibility</i>
											<span>{{ $t('Detail') }}</span>
										</a>

										<a v-if="isUserCan('admin_product_action_edit_modal')" @click="showUpdateProduct(product, 'product_detail')">
											<i class="material-icons md-xs">edit</i>
											<span>{{ $t('Edit') }}</span>
										</a>

										<a :href="$router.resolve({ name: 'adminProductEdit', params: { id: product._id.$oid ? product._id.$oid : product._id }, }).href" target="_blank" v-if="isCanEditProduct">
											<i class="material-icons md-xs">edit</i>
											<span>{{ $t('Edit') }}</span>
										</a>

										<a @click="showConfirmDeleteProduct(product)" v-if="isUserCan('product_delete')">
											<i class="material-icons md-xs">delete</i>
											<span>{{ $t('Delete') }}</span>
										</a>
									</div>

									<div class="d-flex flex-row">
										<router-link v-if="isProductLive(product)" target="_blank" :to="`${productPreviewTarget}${previewLink(product)}`">
											<i class="material-icons md-xs">link</i>
											<span>{{ $t('Preview') }}</span>
										</router-link>

										<div v-if="!isProductLive(product)"></div>

										<a @click="showConfirmDuplicateProduct(product)">
											<i class="material-icons md-xs">content_copy</i>
											<span>{{ $t('Duplicate') }}</span>
										</a>
									</div>
								</div>
							</div>
						</td>

						<!-- Supplier -->
						<td v-if="isShowColumn('supplier')" class="text-left w-150">
							<div class="supplier-name">{{ getSupplierName(product) }}</div>
							<div class="supplier-code">{{ product.supplier_code }}</div>
						</td>

						<!-- Seller -->
						<td v-if="isShowColumn('seller') && !isSaleCategoryDistributor" class="text-left w-150">
							<div @click="onShowSeller(product._id)" class="seller-name cursor-pointer text-primary text-bold">{{product.seller_count}}</div>
						</td>

						<td v-if="isShowColumn('seller') && isSaleCategoryDistributor" class="text-left w-150 wholesale-count">
							<div class="seller-name cursor-pointer text-primary text-bold">
								<div @click="onShowSeller(product.distributor.assigned_user, true, product.distributor.visibility)" v-if="product.distributor && product.distributor.visibility === 'private'">
									{{ product.distributor.assigned_user.length || 0 }}
								</div>
								<div @click="onShowSeller(userWholesale, true)" v-else>
									{{totalUserFeat || 0}}
								</div>
							</div>
						</td>

						<!-- Type -->
						<td v-if="isShowColumn('type')" class="text-left">
							<div class="type">{{ product.type }}</div>
						</td>

						<!-- Aggregated Section -->
						<td class="text-left" v-if="isExpandEnabled && !isSaleCategoryDistributor">
							<div class="d-flex">

								<!-- Variation Name Section -->
								<div v-if="isShowColumn('variations')" class="text-left w-250">
									<div v-if="product.type === 'simple'">-</div>
									<div v-else>
										<div
											class="row d-flex align-items-start mr-4"
											:class="{
												'd-none': !product.is_variations_expanded && idx >= variationShownLimit,
												...columnSpacing(product, idx)
											}"
											v-for="(variation, idx) in getSplicedProductVariations(index)"
											:key="idx"
										>
											<div class="col-6 h-50" v-tooltip="getVariationTooltip(variation, 0)">
												<div class="d-flex align-items-start">
													<i
														class="material-icons mr-1 product-status variation-status"
														:class="{
															'text-success': typeof variation.enabled === 'undefined' || variation.enabled,
															'text-danger': typeof variation.enabled !== 'undefined' && !variation.enabled,
														}"
														v-tooltip="`Status Variasi ${(typeof variation.enabled !== 'undefined' && !variation.enabled) ? 'Tidak' : ''} Aktif`"
													>circle</i>
													<span>{{ getDisplayedVariationName(variation, 0) }}</span>
												</div>
											</div>
											<div class="col-6 h-50" v-tooltip="getVariationTooltip(variation, 1)">
												{{ getDisplayedVariationName(variation, 1) }}
											</div>
										</div>
									</div>
								</div>

								<!-- Product Price Section -->
								<div v-if="isShowColumn('price')" class="text-left w-128">
									<div
										class="product-price"
										v-if="product.type === 'variable'"
									>
										<div
											class="row"
											:class="columnSpacing(product, idx)"
											v-for="(variant, idx) in getSplicedProductVariations(index)"
											:key="idx"
										>
											<div class="col h-50">
												<!-- {{ getProductVariantPrice(variant, product) }} -->
												{{ formatMoney(variant.price) }}
											</div>
										</div>
									</div>
									<div
										v-else
										class="product-price"
									>
										<!-- {{ getProductPrice(product) }} -->
										{{ formatMoney(product.price) }}
									</div>
								</div>

								<!-- Commission Section -->
								<div v-if="isShowColumn('commision')" class="text-left w-150">
									<div
										class="commission"
										v-if="product.type === 'variable' && eachVariantHasCommission(index)"
									>
										<div
											class="row"
											:class="columnSpacing(product, idx)"
											v-for="(variant, idx) in getSplicedProductVariations(index)"
											:key="idx"
										>
											<div class="col h-50">
												{{ getVariantCommissionValueFormated(variant) }}
											</div>
										</div>
									</div>
									<div
										class="commission"
										v-else-if="product.type === 'variable' && !eachVariantHasCommission(index)"
									>
										<div
											class="row"
											:class="columnSpacing(product, idx)"
											v-for="(variant, idx) in getSplicedProductVariations(index)"
											:key="idx"
										>
											<div class="col h-50">
												{{ getCommissionValueFormated(product) }}
											</div>
										</div>
									</div>
									<div class="commission" v-else>{{ getCommissionValueFormated(product) }}</div>
									<div class="row-actions hidden-sm" v-if="!product.is_deleted">
										<a @click="showUpdateProduct(product, 'commission')" v-if="isUserCan('admin_product_edit_commision')">
											<i class="material-icons md-xs">edit</i>
											<span>{{ $t('Edit') }}</span>
										</a>
									</div>
					</div>

					<div v-if="isShowColumn('product_commission')" class="text-left w-150">
						<div class="commission-config-summary">
							<div class="commission-config-primary">{{ formatCommissionSummary(product) }}</div>
							<div class="commission-config-impact">{{ getCommissionImpactLabel(product) }}</div>
							<div class="row-actions hidden-sm" v-if="!product.is_deleted">
								<a @click="openCommissionModal(product)" v-if="isUserCan('admin_product_edit_commision')">
									<i class="material-icons md-xs">tune</i>
									<span>Commission Settings</span>
								</a>
							</div>
						</div>
					</div>

					<!-- Margin Section -->
								<div v-if="isShowColumn('margin')" class="text-left w-128">
									<div
										class="margin"
										v-if="product.type === 'variable' && eachVariantHasMargin(index)"
									>
										<div
											class="row"
											:class="columnSpacing(product, idx)"
											v-for="(variant, idx) in getSplicedProductVariations(index)"
											:key="idx"
										>
											<div class="col h-50">
												{{ formatMoney(variant.margin) }}
											</div>
										</div>
									</div>
									<div
										class="margin"
										v-else-if="product.type === 'variable' && !eachVariantHasMargin(index)"
									>
										<div
											class="row"
											:class="columnSpacing(product, idx)"
											v-for="(variant, idx) in getSplicedProductVariations(index)"
											:key="idx"
										>
											<div class="col h-50">
												{{ formatMoney(product.dropship.margin) }}
											</div>
										</div>
									</div>
									<div class="margin" v-else>{{ formatMoney(product.dropship.margin) }}</div>
									<div class="row-actions hidden-sm" v-if="!product.is_deleted">
										<a @click="showUpdateProduct(product, 'margin')" v-if="isUserCan('admin_product_edit_margin')">
											<i class="material-icons md-xs">edit</i>
											<span>{{ $t('Edit') }}</span>
										</a>
									</div>
								</div>

								<!-- Product Sourcing Fee Section -->
								<div v-if="isShowColumn('product_sourcing_fee')" class="text-left w-200">
									<div class="psf">{{ getProductSourcingFee(product) }}</div>
									<div class="row-actions hidden-sm" v-if="!product.is_deleted">
										<a @click="showUpdateProduct(product, 'product_sourcing_fee')" v-if="isUserCan('admin_product_edit_product_sourcing_fee')">
											<i class="material-icons md-xs">edit</i>
											<span>{{ $t('Edit') }}</span>
										</a>
									</div>
								</div>

							<!-- Handling Fee Section -->
								<div v-if="isShowColumn('handling_fee')" class="text-left w-200">
									<div class="hf content-center">
										<div class="font-weight-bold">{{ formatMoney(product.fee_config.value || 0) }}</div>
										<div class="badge badge-warning">{{ formatMoney(product.fee_config.fee_supplier || 0) }}</div>
										<br />
										<div class="badge badge-primary">{{ formatMoney(product.fee_config.margin_platform || 0) }}</div>
										<div class="text-success small">{{ product.fee_config.type === 'per_order' ? 'per order' : 'per qty' }}</div>
									</div>
									<div class="row-actions hidden-sm" v-if="!product.is_deleted">
										<a @click="showUpdateProduct(product, 'handling_fee')">
											<i class="material-icons md-xs">edit</i>
											<span>{{ $t('Edit') }}</span>
										</a>
									</div>
								</div>

								<!-- Recommended Price Section -->
								<div v-if="isShowColumn('recommended_price')" class="text-left w-180">
									<div
										class="recommended-price"
										v-if="product.type === 'variable'"
									>
										<div
											class="row"
											:class="columnSpacing(product, idx)"
											v-for="(variant, idx) in getSplicedProductVariations(index)"
											:key="idx"
										>
											<div class="col h-50">
												{{ getVariantFinalPrice(product, idx) }}
											</div>
										</div>
									</div>
									<div class="recommended-price" v-else>{{ getFinalPrice(product) }}</div>
								</div>

								<!-- Stock Section -->
								<div v-if="isShowColumn('stock')" class="text-left w-128">
									<div class="product-stock">
										<div
											class="stock"
											v-if="product.type === 'variable'"
										>
											<div
												class="row"
												:class="columnSpacing(product, idx)"
												v-for="(variant, idx) in getSplicedProductVariations(index)"
												:key="idx"
											>
												<div class="col h-50">
													<b class="text-primary" v-if="getVariantStockQuantity(variant) > 0">
														<span>{{ getVariantStockQuantity(variant) }} in stock</span>
													</b>
													<b class="text-danger" v-if="getVariantStockQuantity(variant) <= 0">{{ $t('Out of stock') }}</b>
												</div>
											</div>
										</div>
										<div v-else>
											<template v-if="product.stock.enabled">
												<b class="text-primary" v-if="getStockQuantity(product) > 0">
													<span>{{ getStockQuantity(product) }} in stock</span>
												</b>
												<b class="text-danger" v-if="getStockQuantity(product) <= 0">{{ $t('Out of stock') }}</b>
											</template>
											<div v-else>-</div>
										</div>
										<div class="row-actions hidden-sm" v-if="!product.is_deleted">
											<a @click="showUpdateProduct(product, 'stock')" v-if="isUserCan('admin_product_edit_stock')">
												<i class="material-icons md-xs">edit</i>
												<span>{{ $t('Edit') }}</span>
											</a>
											<a v-if="isRoleAdmin || isRoleSuperAdmin" :href="`/admin/product-history?supplier_id=${product.user_id}&product_id=${product._id}`" target="_blank">
												<i class="material-icons md-xs">history</i>
												<span>{{ $t('History') }}</span>
											</a>
										</div>
									</div>
								</div>

							</div>

							<!-- Expand Toggle -->
							<div
								class="d-flex justify-content-center cursor-pointer mt-2"
								v-if="isShowExpand(product)"
								@click="toggleExpandVariations(index)"
							>
								<div class="line"></div>
								<div class="text-primary text-bold mx-2 d-flex align-items-center">
									<span>{{ toggleLabel(index) }}</span>
									<i class="material-icons" v-if="!getProductVariationsExpandStatus(index)">expand_more</i>
									<i class="material-icons" v-else>expand_less</i>
								</div>
								<div class="line"></div>
							</div>
						</td>

						<!-- Price -->
						<!-- <td v-if="isShowColumn('price')" class="text-left">
							<div class="product-price" v-tooltip="`Harga supplier: ${formatMoney(product.price)}`">{{ getProductPrice(product) }}</div>
						</td> -->

						<!-- Commission -->
						<!-- <td v-if="isShowColumn('commision')" class="text-left">
							<div class="commission">{{ getCommissionValueFormated(product) }}</div>
							<div class="row-actions hidden-sm" v-if="!product.is_deleted">
								<a @click="showUpdateProduct(product, 'commission')" v-if="isUserCan('admin_product_edit_commision')">
									<i class="material-icons md-xs">edit</i>
									<span>{{ $t('Edit') }}</span>
								</a>
							</div>
						</td> -->

						<!-- Margin -->
						<!-- <td v-if="isShowColumn('margin')" class="text-left">
							<div class="commission">{{ formatMoney(product.dropship.margin) }}</div>
							<div class="row-actions hidden-sm" v-if="!product.is_deleted">
								<a @click="showUpdateProduct(product, 'margin')" v-if="isUserCan('admin_product_edit_margin')">
									<i class="material-icons md-xs">edit</i>
									<span>{{ $t('Edit') }}</span>
								</a>
							</div>
						</td> -->

						<!-- Recomended Price -->
						<!-- <td v-if="isShowColumn('recommended_price')" class="text-left">
							<div class="commission">{{ getFinalPrice(product) }}</div>
						</td> -->

						<!-- Stock -->
						<!-- <td v-if="isShowColumn('stock')">
							<div class="product-stock">
								<template v-if="product.stock.enabled">
									<b class="text-primary" v-if="getStockQuantity(product) > 0">
										<span>{{ getStockQuantity(product) }} in stock</span>
									</b>
									<b class="text-danger" v-if="getStockQuantity(product) <= 0">{{ $t('Out of stock') }}</b>
								</template>
								<div v-else>-</div>
							</div>
						</td> -->

						<!-- Visibility -->
						<td v-if="isShowColumn('visibility') && !isSaleCategoryDistributor">
							<div class="product-status" :class="getProductVisibilityStatus(product).color">{{ getProductVisibilityStatus(product).status }}</div>
							<div class="row-actions hidden-sm" v-if="!product.is_deleted">
								<a @click="showUpdateProduct(product, 'visibility')">
									<i class="material-icons md-xs">edit</i>
									<span>{{ $t('Edit') }}</span>
								</a>
							</div>
						</td>

						<!-- Distributor Status Section -->
						<td v-if="isShowColumn('distributor_status') && isUserCan('admin_product_action_private_order')" class="text-left w-200">
							<div class="product-status">
								<span class="text-success" v-if="getDistributorStatus(product)">Enabled</span>
								<span class="text-danger" v-else>Disabled</span>
							</div>
							<div class="row-actions hidden-sm" v-if="!product.is_deleted">
								<a @click="showUpdateProduct(product, 'distributor_status')">
									<i class="material-icons md-xs">edit</i>
									<span>{{ $t('Edit') }}</span>
								</a>
							</div>
						</td>

						<td class="text-left" v-if="isSaleCategoryDistributor">
							<div class="d-flex">
								<!-- Distributor Price Section -->
								<div v-if="isShowColumn('distributor_price')" class="text-left w-200">
									<div class="distributor-price">
										{{ getDistributorPrice(product) }}
									</div>
									<div class="row-actions hidden-sm" v-if="!product.is_deleted">
										<a @click="showUpdateProduct(product, 'distributor_price')">
											<i class="material-icons md-xs">edit</i>
											<span>{{ $t('Edit') }}</span>
										</a>
									</div>
								</div>

								<!-- Distributor Slash Price Section -->
								<div v-if="isShowColumn('distributor_slash_price')" class="text-left w-200">
									<div class="distributor-slash-price">
										{{ getDistributorSlashPrice(product) }}
									</div>
									<div class="row-actions hidden-sm" v-if="!product.is_deleted">
										<a @click="showUpdateProduct(product, 'distributor_slash_price')">
											<i class="material-icons md-xs">edit</i>
											<span>{{ $t('Edit') }}</span>
										</a>
									</div>
								</div>

								<!-- Distributor Wholesale Price Section -->
								<div v-if="isShowColumn('distributor_wholesale_price')" class="text-left w-300">
									<div class="distributor-slash-price">
										<div v-if="getDistributorWholesaleLength(product) > 0" class="mr-4">
											<table class="table-wholesale w-100 text-center">
												<tr>
													<td class="text-bold">Jumlah</td>
													<td class="text-bold">Diskon</td>
													<td class="text-bold">Harga Satuan</td>
												</tr>
												<tr v-for="(item, idx) in getDistributorWholesale(product)" :key="idx">
													<td>{{ `${item.min} - ${item.max}` }}</td>
													<td>{{ `${item.discount}%` }}</td>
													<td>{{ formatMoney(item.price) }}</td>
												</tr>
											</table>
										</div>
										<span v-else>-</span>
									</div>
									<div class="row-actions hidden-sm" v-if="!product.is_deleted">
										<a @click="showUpdateProduct(product, 'distributor_wholesale_price')">
											<i class="material-icons md-xs">edit</i>
											<span>{{ $t('Edit') }}</span>
										</a>
									</div>
								</div>

								<!-- Distributor Stock Section -->
								<div v-if="isShowColumn('distributor_stock')" class="text-left w-128">
									<div class="distributor-stock">
										<b class="text-primary" v-if="getDistributorStock(product) > 0">
											<span>{{ getDistributorStock(product) }} in stock</span>
										</b>
										<b class="text-danger" v-else-if="getDistributorStock(product) <= 0">{{ $t('Out of stock') }}</b>
										<span v-else>-</span>
									</div>
									<div class="row-actions hidden-sm" v-if="!product.is_deleted">
										<a @click="showUpdateProduct(product, 'distributor_stock')" v-if="isUserCan('admin_product_edit_stock')">
											<i class="material-icons md-xs">edit</i>
											<span>{{ $t('Edit') }}</span>
										</a>
										<a v-if="isRoleAdmin || isRoleSuperAdmin" :href="`/admin/product-history?supplier_id=${product.user_id}&product_id=${product._id}`" target="_blank">
											<i class="material-icons md-xs">history</i>
											<span>{{ $t('History') }}</span>
										</a>
									</div>
								</div>

								<!-- Distributor Visibility -->
								<div v-if="isShowColumn('distributor_visibility')" class="text-left w-150">
									<div class="product-status" :class="getProductVisibilityStatus(product, 'wholesale').color">
										{{ getProductVisibilityStatus(product, 'wholesale').status }}
									</div>
									<div class="row-actions hidden-sm" v-if="!product.is_deleted">
										<a @click="showUpdateProduct(product, 'distributor_visibility')">
											<i class="material-icons md-xs">edit</i>
											<span>{{ $t('Edit') }}</span>
										</a>
									</div>
								</div>
							</div>
						</td>

						<!-- status deleted -->
						<td v-if="isShowColumn('status') && product.is_deleted" class="text-left">
							<div class="d-flex">
								<div
									class="product-status d-flex align-items-center"
									:class="{
										'active': !product.is_deleted,
										'deleted': product.is_deleted
									}">
									<i class="material-icons mr-1">circle</i>
									<div class="text-capitalize">
										<span v-if="!product.is_deleted">Active</span>
										<span v-else>Deleted</span>
									</div>
								</div>
							</div>
						</td>

						<!-- Status -->
						<td v-if="!product.is_deleted && isShowColumn('status')">
							<div class="product-status" :class="getProductDisplayStatus(product.status).color">{{ getProductDisplayStatus(product.status, product.is_verified).status }}</div>
							<div class="note ml-3 row-actions hidden-sm text-primary" role="button" v-if="product.suspend_note && product.suspend_note !== ''">
								<i class="bi bi-card-text" v-tooltip="product.suspend_note"></i>
							</div>
						</td>

						<!-- Max Qty -->
						<td v-if="isShowColumn('max_qty')">
							<div class="product-status">
								<div v-if="getMaxQtyConfig(product)">
									<span :class="{
										'text-success': getMaxQtyConfig(product, 'enabled'),
										'text-danger': !getMaxQtyConfig(product, 'enabled')
									}">
										{{ getMaxQtyConfig(product, 'enabled') ? 'Enabled' : 'Disabled' }}
									</span> : <span class="text-primary">
										{{ getMaxQtyConfig(product, 'value') }}
									</span>
								</div>
								<div v-else>-</div>
							</div>
							<div class="row-actions hidden-sm" v-if="!product.is_deleted">
								<a @click="showUpdateProduct(product, 'max_qty')">
									<i class="material-icons md-xs">edit</i>
									<span>{{ $t('Edit') }}</span>
								</a>
							</div>
						</td>

						<!-- Blacklisted Sellers -->
						<td v-if="isShowColumn('blacklisted_sellers')">
							<div @click="showUpdateProduct(product, 'blacklisted_sellers')" class="cursor-pointer text-primary text-bold">
								{{ getBlacklistedSellerCount(product) }}
							</div>
						</td>

						<!-- Changes -->
						<td v-if="isShowColumn('changes')">
							<div class="product-changes text-warning" v-if="product.change_logs != null && product.status == 'request'">
								<div
									role="button"
									@click="showCompareLog(product)"
									v-for="(item, index) in getProductChangeLogs(product)"
									:key="index">
									<small>{{index + 1}}. {{item.description}}</small>
								</div>
							</div>
						</td>

						<!-- Change History -->
						<td v-if="isShowColumn('change_history')" class="text-left">
							<button class="btn btn-sm btn-light no-wrap" @click="showProductTimeline(product)">Show Detail</button>
						</td>

						<!-- Created At -->
						<td v-if="isShowColumn('created_at')" class="text-left">
							<div class="order-date"> {{ formatDate(product.created_at) }}</div>
						</td>
						<!-- Timestamps -->
						<td v-if="isShowColumn('timestamps')" class="text-left">
							<div v-html="showTimeStamps(product.timestamps)">

							</div>
						</td>

						<!-- deleted by -->
						<!-- <td class="text-left">
							<div class="d-flex flex-column">
								<div>
									<b class="" v-if="product.deleted_by_name">{{ product.deleted_by_name }}</b>
								</div>
								<div class="text-muted">
									<small v-if="product.deleted_at">{{ formatDate(product.deleted_at) }}</small>
									<small v-else-if="product.deleted_at_old">{{ formatDate(product.deleted_at_old.date) }}</small>
								</div>
							</div>
						</td> -->

						<!-- Action -->
						<td v-if="isShowColumn('action')">
							<div class="btn-group">
								<button class="btn btn-default btn-sm dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false">
									{{ $t('Action') }}
								</button>
								<div class="dropdown-menu">
									<template v-if="product.is_deleted">
										<button :disabled="!isUserCan('admin_product_action_restore')" type="button" class="dropdown-item" v-tooltip="'Restore Deleted Product'" @click="restore(product)">
											<i class="material-icons">restore_from_trash</i> {{ $t('Restore') }}
										</button>
									</template>
									<template v-else>
										<button :disabled="!isUserCan('admin_product_action_pricing')" type="button" class="dropdown-item" v-tooltip="'Pricing'" v-if="(product.status !== 'pricing' && product.status !== 'live')" @click="pricing(product)">
											<i class="material-icons">sell</i> Pricing
										</button>
										<button :disabled="!isUserCan('admin_product_action_recontent')" type="button" class="dropdown-item" v-tooltip="'Marketing Kit'" v-if="(product.status !== 'recontent' && product.status !== 'live')" @click="recontent(product)">
											<i class="material-icons">article</i> Marketing Kit
										</button>
										<button :disabled="!isUserCan('admin_product_action_landing_page')" type="button" class="dropdown-item" v-tooltip="'Landing Page'" v-if="(product.status !== 'landing_page' && product.status !== 'live')" @click="setLandingPageStatus(product)">
											<i class="material-icons">article</i> Landing Page
										</button>
										<button :disabled="!isUserCan('admin_product_action_verification')" type="button" class="dropdown-item" v-tooltip="'Verification'" v-if="(product.status !== 'request' && product.status !== 'live')" @click="verification(product)">
											<i class="material-icons">checklist</i> Verification
										</button>
										<template v-if="!isPriceChange(product)">
											<button :disabled="!isUserCan('admin_product_action_approve')" type="button" class="dropdown-item" v-tooltip="'Approve'" v-if="(product.status === 'request' && product.status !== 'live')" @click="approve(product)">
												<i class="material-icons">check</i> Approve
											</button>
										</template>
										<template v-else>
											<button :disabled="!isUserCan('admin_product_action_approve')" type="button" class="dropdown-item disabled" v-tooltip="'Approve dapat dilakukan pada ' + getProductChangeActiveDate(product)" v-if="(product.status === 'request' && product.status !== 'live' && !isProductChangeActiveDateThisDay(product))">
												<i class="material-icons">check</i> Approve
											</button>
											<button :disabled="!isUserCan('admin_product_action_approve')" type="button" class="dropdown-item" v-tooltip="'Approve'" v-if="(product.status === 'request' && product.status !== 'live' && isProductChangeActiveDateThisDay(product))" @click="approve(product)">
												<i class="material-icons">check</i> Approve
											</button>
										</template>
										<button :disabled="!isUserCan('admin_product_action_pricing')" type="button" class="dropdown-item" v-tooltip="'Reject Verification'" v-if="(product.status === 'request' && product.status !== 'reject')" @click="reject(product)">
											<i class="material-icons">close</i> Reject Verification
										</button>
										<button :disabled="!isUserCan('admin_product_action_reject_update')" type="button" class="dropdown-item" v-tooltip="'Reject Update'" v-if="(product.status === 'request' && product.is_verified === true && product.is_has_history && isHaveChangelogs(product) > 0)" @click="rejectUpdate(product)">
											<i class="material-icons">close</i> Reject Update
										</button>
										<button :disabled="!isUserCan('admin_product_action_undo')" type="button" class="dropdown-item" v-tooltip="'Undo to Requested'" v-if="((product.status === 'live' || product.status === 'reject') && !hasPriceChangeUpdated(product))" @click="undo(product)">
											<i class="material-icons">undo</i> Undo Approval
										</button>
										<button :disabled="!isUserCan('admin_product_action_suspend')" type="button" class="dropdown-item" v-tooltip="'Suspend Product'" v-if="(product.status !== 'suspended')" @click="suspend(product)">
											<i class="material-icons">block</i> Suspend
										</button>
										<button :disabled="!isUserCan('admin_product_action_unsuspend')" type="button" class="dropdown-item" v-tooltip="'Unsuspend Product and set to Active'" v-if="(product.status === 'suspended')" @click="unsuspend(product)">
											<i class="material-icons">restore</i> Unsuspend
										</button>
										<button :disabled="!isUserCan('admin_product_action_archive')"  type="button" class="dropdown-item" v-tooltip="'Archive Product'" v-if="product.status !== 'disabled'" @click="archive(product)">
											<i class="material-icons">archive</i> Archive
										</button>
										<button :disabled="!isUserCan('admin_product_action_marketing_kit')" type="button" class="dropdown-item" v-tooltip="'Update marketing kit'" @click="showUpdateProduct(product, 'marketing_kit')">
											<i class="material-icons">widgets</i> Marketing Kit
										</button>
										<button :disabled="!isUserCan('admin_product_action_dangerous_goods')" type="button" class="dropdown-item" v-tooltip="'Mark/Unmark As Dangerous Goods'" @click="openModalDangerousGoods(product)">
											<i class="material-icons text-warning">warning</i> {{ dangerousGoodsLabel(product) }} As Dangerous Goods
										</button>
									</template>
								</div>
							</div>
						</td>
					</tr>
					<!-- <tr class="row-empty" v-if="searchResultsEmpty">
						<td colspan="7">
							<div class="list-empty"><i class="material-icons md-48">error_outline</i> No products meet your search query.</div>
						</td>
					</tr> -->
				</tbody>
			</table>
			<!-- <div class="list-empty" v-if="isNoProducts"><i class="material-icons">error_outline</i> You haven't created any products yet.</div> -->
			<div class="list-empty table-empty" v-if="products.length === 0 && isFetching === false">
				<i class="material-icons mr-2 va-m">error_outline</i>
				<span class="va-m">{{ $t('No products was found') }}</span>
			</div>
		</div>

		<!-- Table Loader -->
		<div class="table-fetch-status" v-if="isFetching">
			<div class="is-loading large dark m-auto"></div>
		</div>
	</div>

	<!-- Modals -->
	<div class="modals">

		<!-- Table Filter -->
		<modal
			class="table-filter-modal"
			size="x-large"
			@close="isShowFilter = false"
			v-if="isShowFilter">
			<div slot="header">
				<h3><i class="material-icons">filter_list</i>Filter Products</h3>
			</div>
			<div slot="body">
				<!-- user id -->
				<!-- <div class="form-group">
					<label for="">
						<b class="">
							User ID
						</b>
					</label>
					<input type="text" class="form-control" v-model="userId">
				</div> -->
				<!-- Supplier -->
				<div class="form-group">
					<label
						><b>{{ $t('Supplier') }}</b></label
					>
					<multiselect
						v-model="selectedSupplier"
						class="orders-status-list multiselect-auto-width form-control"
						placeholder="Select Supplier (Name - Business Name - Code)"
						:custom-label="supplierLabel"
						track-by="email"
						:options="supplierOptions"
						:show-labels="false"
						:allow-empty="true"
						:multiple="true"
					>
						<span slot="noResult">{{ $t('No Supplier found') }}</span>
					</multiselect>
				</div>

				<!-- Blacklisted Sellers -->
				<div class="form-group">
					<multiselect-dropshipper
						:label="'Blacklisted Sellers'"
						:selected-dropshippers.sync="blacklistedSellers"
					/>
				</div>

				<!-- Sale Category -->
				<div class="form-group" v-if="isUserCan('admin_product_action_private_order')">
					<label><b>Sale Category</b></label>
					<select class="form-control" v-model="saleCategory">
						<option value="catalog">Catalog</option>
						<option value="wholesale">Wholesale</option>
					</select>
				</div>

				<!-- status -->
				<div class="form-group">
					<label for="">
						<b class="">
							Status Product
						</b>
					</label>
					<select class="form-control" v-model="status">
						<option value="all">All</option>
						<option value="live">Active</option>
						<option value="pricing">Pricing</option>
						<option value="recontent">Marketing Kit</option>
						<option value="landing_page">Landing Page</option>
						<option value="request">Verification</option>
						<option value="updated">Updated</option>
						<option value="out_of_stock">Out of Stock</option>
						<option value="reject">Rejected</option>
						<option value="disabled">Archived</option>
						<option value="suspended">Suspended</option>
					</select>
				</div>
				<!-- visibility -->
				<div class="form-group">
					<label for="">
						<b class="">
							Visibility Product
						</b>
					</label>
					<select class="form-control" v-model="visibility">
						<option value="all">All</option>
						<option value="public">Public</option>
						<option value="private">Private</option>
					</select>
				</div>
				<!-- deleted -->
				<div class="form-group">
					<label for="">
						<b class="">
							Status Deleted
						</b>
					</label>
					<select class="form-control" v-model="deleted">
						<option value="all">All</option>
						<option value="1">Deleted Product</option>
						<option value="0">Active Product</option>
					</select>
				</div>
				<!-- landing pages -->
				<div class="form-group">
					<label for="">
						<b class="">
							Landing Page
						</b>
					</label>
					<select class="form-control" v-model="landingPage">
						<option value="all">All</option>
						<option value="1">Empty</option>
						<option value="0">Not Empty</option>
					</select>
				</div>
				<!-- marketing kit -->
				<div class="form-group">
					<label for="">
						<b class="">
							Marketing Kit
						</b>
					</label>
					<select class="form-control" v-model="marketingKit">
						<option value="all">All</option>
						<option value="1">Empty</option>
						<option value="0">Not Empty</option>
					</select>
				</div>
				<!-- tag -->
				<div class="form-group">
					<label><b>Tag</b></label>
					<select class="form-control" v-model="selectedTag">
						<option value="all">All</option>
						<option v-for="(tag, idx) in filterTags" :key="idx" :value="tag.type">{{ tag.label }}</option>
					</select>
				</div>
				<!-- name -->
				<div class="form-group">
					<label for="">
						<b class="">
							Product Name
						</b>
					</label>
					<input type="text" class="form-control" v-model="productName">
				</div>

				<!-- Filter Date -->
				<div class="form-group mt-4">
					<label>
						<b>{{ $tc('FIlter Date') }} </b>
						<i
							class="material-icons info"
							v-tooltip="'Filter by date'"
							>info</i
						>
					</label>
					<div class="well mb-3">
						<div class="row">
							<!-- Type -->
							<div class="col-md-4">
								<div class="form-group">
									<label><b>Filter Date Type</b></label
									>
									<select class="form-control" v-model="dateType">
										<option value="" disabled>Pilih Tanggal</option>
										<option value="timestamps.pricing_at">Pricing at</option>
										<option value="timestamps.recontent_at">Marketing Kit at</option>
										<option value="timestamps.landing_page_at">Landing Page at</option>
										<option value="timestamps.verified_at">Verified at</option>
										<option value="timestamps.updated_at">Updated at</option>
										<option value="timestamps.live_at">Live at</option>
										<option value="timestamps.rejected_at">Rejected at</option>
										<option value="timestamps.disabled_at">Disabled at</option>
										<option value="timestamps.suspended_at">Suspended at</option>
									</select>
								</div>
							</div>
							<!-- Return Date Since -->
							<div class="col-md-4">
								<div class="form-group">
									<label
										><b>{{ $tc('_.processingDateSince') }}</b></label
									>
									<input
										type="date"
										class="input form-control"
										placeholder="dd/mm/yyyy"
										v-model="since"
									/>
								</div>
							</div>
							<!-- Processing Date Until -->
							<div class="col-md-4">
								<div class="form-group">
									<label
										><b>{{ $tc('_.processingDateUntil') }}</b></label
									>
									<input
										type="date"
										class="input form-control"
										placeholder="dd/mm/yyyy"
										v-model="until"
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div slot="footer">
				<button type="button" class="btn btn-light" @click="isShowFilter = false">{{ $t('Close') }}</button>
				<button type="button" class="btn btn-primary" @click="applyFilter">Apply</button>
			</div>
		</modal>

		<!-- Modal Filter -->
		<modal
			class="table-filter-modal"
			size="medium"
			@close="isShowConfirmRestore = false"
			v-if="isShowConfirmRestore">
			<div slot="header">
				<h3>Confirm Restore</h3>
			</div>
			<div slot="body">
				<div class="text-center">
					Are you sure want to restore product <b class="ml-1" v-if="selectedProduct && selectedProduct.name"> {{ selectedProduct.name }}</b> <template v-else>-</template>
				</div>
			</div>
			<div slot="footer">
				<button type="button" class="btn btn-light" @click="isShowConfirmRestore = false">{{ $t('Close') }}</button>
				<button type="button" class="btn btn-primary" @click="doRestore" :disabled="isRestoring">Submit</button>
			</div>
		</modal>

		<!-- Modal Change Status -->
		<modal
			class="table-change-status-modal"
			size="medium"
			@close="isShowConfirmChangeStatus = false"
			v-if="isShowConfirmChangeStatus">
			<div slot="header">
				<h3>Confirm Status</h3>
			</div>
			<div slot="body">
				<div class="text-left">
					{{ messageConfirmChangeStatus }} <b class="ml-1" v-if="selectedProduct && selectedProduct.name"> {{ selectedProduct.name }} ?</b> <template v-else>-</template>
				</div>
				<small class="text-danger" v-if="isDistributorErrorOnApprove">
					<div>Terdapat error pada distributor :</div>
					<div v-for="(error, idx) in distributorErrors" :key="idx">
						<span>- {{ error }}</span>
					</div>
				</small>
				<div class="form-group mt-2" v-if="changeStatusValue === 'suspended'">
					<label>Suspend Note</label>
					<textarea class="form-control" v-model="suspendNote" rows="3" placeholder="Tulis alasan produk ditangguhkan"></textarea>
					<div class="text-danger" v-if="suspendNoteValidation != ''">{{ suspendNoteValidation }}</div>
				</div>
			</div>
			<div slot="footer">
				<button type="button" class="btn btn-light" @click="isShowConfirmChangeStatus = false">{{ $t('Close') }}</button>
				<button
					type="button"
					class="btn btn-primary"
					@click="doChangeStatus"
					:disabled="isChangeStatus || isDistributorErrorOnApprove"
				>
					Submit
				</button>
			</div>
		</modal>

		<!-- Bulk Restore Product Confirm -->
		<modal
			class="coupon-editor-modal"
			size="medium"
			@close="isShowConfirmRestoreBulk = false"
			v-if="isShowConfirmRestoreBulk">
			<div slot="header">
				<h3>
					<i class="material-icons">restore</i>
					<span class="ml-1">{{ $t('Restore Product') }}</span>
				</h3>
			</div>
			<div slot="body">
				<p>{{ $t('Are you sure want to restore') }} {{ selectedProducts.length }} {{ $t('products') }}?<br>{{ $t('All') }} <b>{{ $t('orders') }}</b> {{ $t('from these products will be restored too') }}.</p>
				<p class="mb-2"><b>{{ $t('Products to be restored') }}:</b></p>
				<div>
					<div
						v-for="(product, index) in selectedProductsData"
						:key="index">
						<small>{{index + 1}}. {{product.name}}</small>
					</div>
				</div>
			</div>
			<div slot="footer">
				<button type="button" class="btn btn-light" @click="isShowConfirmRestoreBulk = false">{{ $t('Cancel') }}</button>
				<button type="button" class="btn btn-primary" :class="{ 'is-loading': isRestoring }" @click="bulkRestore">
					<i class="material-icons">restore</i>
					<span>{{ $t('Confirm Restore') }}</span>
				</button>
			</div>
		</modal>

		<!-- Bulk Delete Product Confirm -->
		<modal
			class="coupon-editor-modal"
			size="medium"
			@close="isShowDeleteProductBulk = false"
			v-if="isShowDeleteProductBulk">
			<div slot="header">
				<h3>
					<i class="material-icons">delete</i>
					<span class="ml-1">{{ $t('Delete Product') }}</span>
				</h3>
			</div>
			<div slot="body">
				<p>{{ $t('Are you sure want to delete') }} {{ selectedProducts.length }} {{ $t('products') }}?<br>{{ $t('All') }} <b>{{ $t('orders') }}</b> {{ $t('from these products will be deleted too') }}.</p>
				<p class="mb-2"><b>{{ $t('Products to be deleted') }}:</b></p>
				<div>
					<div
						v-for="(product, index) in selectedProductsData"
						:key="index">
						<small>{{index + 1}}. {{product.name}}</small>
					</div>
				</div>
			</div>
			<div slot="footer">
				<button type="button" class="btn btn-light" @click="isShowDeleteProductBulk = false">{{ $t('Cancel') }}</button>
				<button type="button" class="btn btn-danger" :class="{ 'is-loading': isDeleting }" @click="bulkDelete">
					<i class="material-icons">delete</i>
					<span>{{ $t('Confirm Delete') }}</span>
				</button>
			</div>
		</modal>

		<modal
			class="coupon-editor-modal"
			size="medium"
			@close="closeModalBulkUpdateBlacklistedSellers"
			v-if="isShowModalBulkUpdateBlacklistedSellers">
			<div slot="header">
				<h3>
					<span class="ml-1">{{ $t('Bulk Update Blacklisted Sellers') }}</span>
				</h3>
			</div>
			<div slot="body">
				<p>{{ $t(`Are you sure want to update`) }} {{ selectedProducts.length }} {{ $t('products') }}? <small><i>*Existing data won't be overwritten</i></small></p>
				<p class="mb-2"><b>{{ $t('Products to be Updated') }}:</b></p>
				<div>
					<div
						v-for="(product, index) in selectedProductsData"
						:key="index"
					>
						<small>{{index + 1}}. {{product.name}}</small>
					</div>
				</div>
				<div class="mt-2">
					<multiselect-dropshipper
						:label="'Blacklisted Sellers'"
						:selected-dropshippers.sync="blacklistedSellers"
					/>
					<table-dropshipper
						class="mt-2"
						:selected-dropshippers.sync="blacklistedSellers"
					/>
				</div>
			</div>
			<div slot="footer">
				<button
					type="button"
					class="btn btn-light"
					@click="closeModalBulkUpdateBlacklistedSellers"
				>
					{{ $t('Cancel') }}
				</button>
				<button
					type="button"
					class="btn btn-primary"
					:class="{ 'is-loading': isBulkUpdateBlacklistedSellers }"
					@click="submitBulkUpdateBlacklistedSellers"
				>
					<span>{{ $t('Confirm') }}</span>
				</button>
			</div>
		</modal>

		<modal
			class="coupon-editor-modal"
			size="medium"
			@close="isShowModalBulkStatus = false"
			v-if="isShowModalBulkStatus">
			<div slot="header">
				<h3>
					<span class="ml-1">{{ $t(`${toTitleCase(modalBulkTitle)} Product`) }}</span>
				</h3>
			</div>
			<div slot="body">
				<p>{{ $t(`Are you sure want to ${toTitleCase(modalBulkTitle)}`) }} {{ selectedProducts.length }} {{ $t('products') }}?<br>{{ $t('All') }} <b>{{ $t('products') }}</b> {{ $t('from these products will be Activating too') }}.</p>
				<p class="mb-2"><b>{{ $t('Products to be Update') }}:</b></p>
				<div>
					<div
						v-for="(product, index) in selectedProductsData"
						:key="index">
						<small>{{index + 1}}. {{product.name}}</small>
					</div>
				</div>
			</div>
			<div slot="footer">
				<button type="button" class="btn btn-light" @click="isShowModalBulkStatus = false">{{ $t('Cancel') }}</button>
				<button type="button" class="btn btn-primary" :class="{ 'is-loading': isBulkLoading }" @click="performBulkAction(nextParam, toTitleCase(modalBulkTitle), `Product ${modalBulkTitle}!`, nextVerified)">
					<span>{{ $t(`Confirm ${toTitleCase(modalBulkTitle)}`) }}</span>
				</button>
			</div>
		</modal>

		<!-- Delete Product Confirm -->
		<modal
			class="coupon-editor-modal"
			size="medium"
			@close="isShowDeleteProduct = false"
			v-if="isShowDeleteProduct">
			<div slot="header"><h3><i class="material-icons">delete</i>Delete Product</h3></div>
			<div slot="body">Are you sure want to delete <b>{{ selectedProduct.name }}</b>?<br>All orders from this products will be deleted too.</div>
			<div slot="footer">
				<button type="button" class="btn btn-light" @click="isShowDeleteProduct = false">Cancel</button>
				<button type="button" class="btn btn-danger" :class="{ 'is-loading': isDeleting }" @click="deleteProduct">
					<i class="material-icons">delete</i>
					<span>Delete</span>
				</button>
			</div>
		</modal>

		<!-- Duplicate Product Confirm -->
		<modal
			class="coupon-editor-modal"
			size="medium"
			@close="isShowDuplicateProduct = false"
			v-if="isShowDuplicateProduct">
			<div slot="header"><h3><i class="material-icons">content_copy</i>Duplicate Product</h3></div>
			<div slot="body">Are you sure want to duplicate <b>{{ selectedProduct.name }}</b>?</div>
			<div slot="footer">
				<button type="button" class="btn btn-light" @click="isShowDuplicateProduct = false">Cancel</button>
				<button type="button" class="btn btn-primary" :class="{ 'is-loading': isDuplicatingProduct }" @click="duplicateProduct(selectedProduct._id)">
					<i class="material-icons">content_copy</i>
					<span>Duplicate</span>
				</button>
			</div>
		</modal>

		<!-- Product Update Modal -->
		<product-update-modal
			:product="selectedProduct"
			:type="updateType"
			@update="updateSelectedProductInList"
			@close="isShowUpdateModal = false"
			v-if="isShowUpdateModal"
		/>

		<commission-settings-modal
			v-if="isShowCommissionModal"
			:product="commissionModalProduct"
			@close="handleCommissionModalClose"
			@success="onCommissionUpdated"
		/>

		<!-- Bulk Handling Fee Modal -->
		<bulk-handling-fee-modal
			ref="bulkHandlingFeeModal"
			:selected-products="selectedProducts"
			@success="fetchProducts(true)"
			@hidden="isBulkUpdateHandlingFee = false"
		/>

		<bulk-commission-modal
			v-if="isShowBulkCommissionModal"
			:selected-products="selectedProducts"
			@close="isShowBulkCommissionModal = false"
			@success="handleBulkCommissionSuccess"
		/>

		<!-- Product Detail -->
		<product-item-detail
			v-if="showCatalogDetail"
			:product="selectedProduct"
			@close="isShowDetail = false"
			:is-loading-detail = "isGetDetail"
		/>

		<!-- Wholesale Product Detail -->
		<wholesale-product-item-detail
			v-else-if="showWholesaleDetail"
			:product="selectedProduct"
			:is-loading="isGetDetail"
			@close="isShowDetail = false"
		/>
	</div>

	<!-- Compare Modal -->
	<modal
		class="coupon-editor-modal"
		size="large"
		@close="isShowCompareLogModal = false"
		v-if="isShowCompareLogModal"
		>
		<div slot="header">
			<h3>Compare Changes</h3>
		</div>
		<div slot="body">
			<div class="row">
				<div class="col-md-6 text-center">Original</div>
				<div class="col-md-6 text-center">Changed</div>
			</div>
			<div class="container body-log-modal">
				<div class="row" v-for="(changes, index) in selectedProduct.change_logs" :key="index">
					<div class="col-md-6 changes-style-current" v-if="filterProps(changes.data.key)">
						<div>
							<h6 class="text-bold">{{ changes.description }}</h6>
							<pre>{{ jsonPretty(currentLog[changes.data.key]) }}</pre>
						</div>
					</div>

					<div class="col-md-6 changes-style" v-if="filterProps(changes.data.key)">
						<div>
							<h6 class="text-bold">{{ changes.description }}</h6>
							<pre v-if="changes.data.key !== 'variations'">{{ jsonPretty(changes.data.value) }}</pre>
							<pre v-else>{{ jsonPretty(excludeTableKey(selectedProduct[changes.data.key], 'table')) }}</pre>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div slot="footer" class="text-center">
			<button type="button" class="btn btn-light" @click="isShowCompareLogModal = false">Close</button>
		</div>
	</modal>

	<!-- modal filter columns  -->
	<!-- Customize Columns -->
	<modal
		class="customize-columns-modal"
		size="large"
		@close="isShowCustomColumns = false"
		v-if="isShowCustomColumns"
	>
		<template slot="header">
			<div class="flex-center">
				<i class="material-icons">view_week</i>
				<h3>Customize Columns</h3>
			</div>
		</template>
		<div slot="body">
			<div class="mb-3">
				<input
					type="text"
					class="form-control"
					placeholder="Search Column.."
					v-model="columnFilter"
				/>
			</div>
			<div
				class="order-columns-category"
				v-for="(columns, category) in categorizedColumns"
				:key="category"
			>
				<div class="order-columns-category-label">{{ category }}</div>
				<div class="row">
					<template v-for="(column, index) in columns" >
						<div
							class="order-columns col-sm-4"
							:class="{ hidden: column.value === 'reseller' && !isAdmin }"
							:key="index"
							v-if="column.label.toLowerCase().indexOf(columnFilter.toLowerCase()) !== -1"
						>
							<div class="form-group mb-1">
								<label>
									<input
										type="checkbox"
										class="input-checkbox input-checkbox-large"
										:value="column.value"
										v-model="selectedColumns"
									/>
									<span></span>
									<span class="input-checkbox-text">{{column.label}}</span>
									<i
										class="material-icons info mt-1"
										v-tooltip="column.info"
										v-if="column.info && column.info !== ''"
									>
										info
									</i>
								</label>
							</div>
						</div>
					</template>
				</div>
			</div>
		</div>
		<div slot="footer">
			<button class="btn btn-light" @click="resetColumns">Cancel</button>
			<button
				class="btn btn-primary"
				:class="{ 'is-loading': isSavingColumns }"
				@click="applyColumns"
			>
				Apply
			</button>
		</div>
	</modal>

	<!-- Modal List Seller -->
	<modal
		class="customize-columns-modal"
		size="large"
		@close="isShowListSeller = false"
		v-if="isShowListSeller"
	>
		<template slot="header">
			<div class="flex-center">
				<h3>List Seller on Product</h3>
			</div>
		</template>
		<div slot="body">
			<div class="products-list table-responsive">
				<table class="products-list-table table table-primary table-striped mb-0">
					<thead>
					<tr>
						<th class="text-left" width="10%">No</th>
						<th class="text-left w-25" width="25%">User Id</th>
						<th class="text-left w-50" width="25%">Nama</th>
					</tr>
					</thead>
					<tbody>
					<!-- Loop untuk menampilkan data yang sesuai dengan halaman aktif -->
					<template v-if="!isFetchingListSeller">
						<tr v-for="(item, index) in paginatedData" :key="'seller-' + index">
							<td>
								{{((currentPage - 1) * 10) + (index + 1)}}
							</td>
							<td>
								<span v-if="item.seller && item.seller._id.$oid">
									{{item.seller._id.$oid}}
								</span>
								<span v-else-if="item && item._id">
									{{item._id}}
								</span>
								<span v-else>
									{{item.user_id}}
								</span>
							</td>
							<td>
								<div class="text-bold">
									<span v-if="item.seller && item.seller.name">
										{{item.seller.name}}
									</span>
									<span v-else>
										{{item.name}}
									</span>
								</div>
								<div class="text-bold">
									<span v-if="item.seller && item.seller.email">
										{{item.seller.email}}
									</span>
									<span v-else>
										{{item.email}}
									</span>
								</div>
							</td>
						</tr>
					</template>

					<!-- Loading state placeholder -->
					<template v-if="isFetchingListSeller">
						<tr v-for="index in 5" :key="'seller-loading-' + index">
							<td>
								<shimmer :width="'20px'" />
							</td>
							<td>
								<shimmer :width="'75px'" />
							</td>
							<td>
								<shimmer class="d-block" :width="'200px'" />
								<shimmer :width="'200px'" />
							</td>
						</tr>
					</template>
					</tbody>
				</table>

				<div class="list-empty table-empty w-100" v-if="paginatedData.length === 0 && !isFetchingListSeller">
					<i class="material-icons mr-2 va-m">error_outline</i>
					<span class="va-m">{{ $t('No Sellers was found') }}</span>
				</div>

					<!-- Pagination Controls -->
					<div v-if="isWholesale && totalPages > 1" class="pagination-container d-flex justify-content-center mt-4" style="gap: 10px">
						<button
							class="btn btn-primary btn-sm"
							:disabled="currentPage === 1"
							@click="changePage(currentPage - 1)"
						>
							Prev
						</button>

						<div class="" style="display: flex; align-items: center">
							<span>Page {{ currentPage }} of {{ totalPages }}</span>
						</div>

						<button
							class="btn btn-primary btn-sm"
							:disabled="currentPage === totalPages"
							@click="changePage(currentPage + 1)"
						>
							Next
						</button>
					</div>
				</div>
		</div>
		<div slot="footer">
			<button class="btn btn-light" @click="isShowListSeller=false">Close</button>
		</div>
	</modal>

	<!-- Modal Product Timeline -->
	<modal-product-timeline
		v-if="isShowModalProductTimeline"
		:selected-product="selectedProductTimeline"
		:filter-label="productTimelineFilterLabel"
		:filter-statics="productTimelineStatics"
		:is-exporting="isExporting"
		:sort-class="sortClassTimeline('created_at')"
		:is-fetching="isFetchingProductTimeline"
		:timeline-data="timelineData"
		:is-load-more-enabled="isLoadMoreEnabled"
		:user="user"
		@assign-filter="assignProductTimelineFilter"
		@export="exportProductTimeline"
		@change-sorting="changeSortingTimeline"
		@load-more="loadMore"
		@close="toggleModalProductTimeline(false)"
	/>

	<!-- Modal Mark/Unmark As Dangerous Goods -->
	<modal-confirm-dangerous-goods
		v-if="isShowModalDangerousGoods"
		:is-saving="isSavingMarkAsDangerousGoods"
		:productName="selectedProduct.name"
		:action="dangerousGoodsAction"
		@close="isShowModalDangerousGoods = false"
		@apply="markAsDangerousGoods"
	/>

	<notifications group="products" position="bottom right" />
</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Modal from '@/components/Modal.vue';
import ModalConfirmDangerousGoods from '@/components/ModalConfirmDangerousGoods.vue';
import ProductItemDetail from '@/components/homepages/sections/partials/ProductItemDetail.vue';
import ProductUpdateModal from '@/components/ProductUpdateModal.vue';
import BulkHandlingFeeModal from '@/components/BulkHandlingFeeModal.vue';
import CommissionSettingsModal from '@/components/admin/products/CommissionSettingsModal.vue';
import Shimmer from '@/components/Shimmer.vue';
import ModalProductTimeline from '@/components/ModalProductTimeline.vue';
import TableDropshipper from '@/components/forms/TableDropshipper.vue';
import ProductStats from '@/components/stats/ProductStats.vue';
import MultiselectDropshipper from '@/components/forms/MultiselectDropshipper.vue';
import Badges from '@/components/products/Badges.vue';
import WholesaleProductItemDetail from '@/components/admin/products/WholesaleProductItemDetail.vue';
import BulkCommissionModal from '@/components/admin/products/BulkCommissionModal.vue';
import adminApi, {
	getProductTimeline,
	exportProductTimeline,
	bulkUpdateBlacklistedSellers,
} from '@/api/admin';
import productApi from '@/api/products';
import userApi, { getUserFeatCount } from '@/api/user';
import statsApi from '@/api/statistic';
import {
	getDateRange,
	formatNumber,
	getAxiosErrorMessage,
	duplicateVar,
	getProductChangeLog,
	formatDate,
	getProductDisplayStatus,
	getProductVisibilityStatus,
	getDropshipFinalPrice,
	getDropshipVariationFinalPrice,
	formatMoney,
	getProductPricePlusCommission,
	getProductVariantPricePlusCommission,
	getCommissionValueFormated,
	getVariantCommissionValueFormated,
	downloadFile,
	groupBy,
	toTitleCase,
	jsonPretty,
	getDateNow,
	getProductBadges,
	validateDistributorWholesale,
} from '@/lib/helper';

import {
	defaultProductColumns,
	defaultProductSourcingFeeConfig,
	statItems,
	FILTER_TAGS,
	DEFAULT_COMMISSION_CONFIG,
} from '@/lib/statics';


const defaultFilterDate = getDateRange();

export default {
	name: 'products',
	components: {
		Modal,
		ModalConfirmDangerousGoods,
		ProductItemDetail,
		ProductUpdateModal,
		BulkHandlingFeeModal,
		BulkCommissionModal,
		CommissionSettingsModal,
		ProductStats,
		Badges,
		Shimmer,
		MultiselectDropshipper,
		ModalProductTimeline,
		TableDropshipper,
		WholesaleProductItemDetail,
	},
	data() {
		return {
			page: 1,
			keyword: '',
			limit: 50,
			sort_by: 'status_number',
			sort: 'asc',
			isAll: false,
			filterDate: defaultFilterDate,
			isShowStock: false,
			isShowDeleteProductBulk: false,
			isShowModalBulkStatus: false,
			isShowModalBulkUpdateBlacklistedSellers: false,
			isShowCommissionModal: false,
			commissionModalProduct: null,
			isBulkUpdateHandlingFee: false,
			modalBulkTitle: '',
			statusOverview: '',
			nextStatus: '',
			nextParam: '',
			isShowBulkCommissionModal: false,
			nextVerified: false,
			isGetDetail: false,
			// isShowButtonUpdatedBulk: false,
			// isShowButtonActiveBulk: false,
			isShowDeleteProduct: false,
			selectedProduct: null,
			selectedProducts: [],
			selectedDropshippers: [],
			isShowFilter: false,
			isDeleting: false,
			isBulkLoading: false,
			isBulkUpdateBlacklistedSellers: false,
			userId: '',
			status: 'all',
			visibility: 'all',
			deleted: '0',
			landingPage: 'all',
			marketingKit: 'all',
			productName: '',
			blacklistedSellers: [],
			isFetching: false,
			products: [],
			isRestoring: false,
			isShowConfirmRestore: false,
			isShowConfirmRestoreBulk: false,
			isShowConfirmChangeStatus: false,
			messageConfirmChangeStatus: 'Are you sure want to approve product',
			changeStatusValue: '',
			suspendNote: '',
			isChangeStatus: false,
			selectedSupplier: [],
			suppliers: [],
			isShowDetail: false,
			isShowUpdateModal: false,
			updateType: 'comission',
			isExporting: false,
			stats: {
				active_count: 0,
				disabled_count: 0,
				out_of_stock_count: 0,
				out_of_stock_simple_count: 0,
				out_of_stock_variable_count: 0,
				pricing_count: 0,
				product_count: 0,
				recontent_count: 0,
				landing_page_count: 0,
				rejected_count: 0,
				requested_count: 0,
				suspended_count: 0,
				updated_count: 0,
			},
			isShowCustomColumns: false,
			allProductsColumns: defaultProductColumns,
			columnFilter: '',
			selectedColumns: [],
			isSavingColumns: false,
			isShowCompareLogModal: false,
			currentLog: {},
			suspendNoteValidation: null,
			since: null,
			until: null,
			dateType: '',
			filterDateType: null,
			variationShownLimit: 3,
			previousStatus: null,
			isFetchingListSeller: false,
			isShowListSeller: false,
			SellerOnProducts: [],
			isWholesale: false,
			wholesaleVisibility: 'public',
			isShowDuplicateProduct: false,
			isDuplicatingProduct: false,
			isFetchingStatistic: false,
			selectedProductTimeline: {},
			isShowModalProductTimeline: false,
			timelineData: [],
			productTimelineStatics: {
				all: {
					label: 'All Update',
					type: 'text',
				},
			},
			productTimelineFilter: null,
			isFetchingProductTimeline: false,
			saleCategory: 'catalog',
			timeline_page: 1,
			timeline_sort_by: 'created_at',
			timeline_sort: 'desc',
			isLoadMoreEnabled: true,
			excludedKeys: ['commission_percentage', 'wholesale'],
			isShowModalDangerousGoods: false,
			isSavingMarkAsDangerousGoods: false,
			dangerousGoodsAction: 'Mark',
			filterTags: FILTER_TAGS,
			selectedTag: 'all',
			distributorErrors: [],
			userWholesale: [],
			totalUserFeat: 0,
			currentPage: 1, // Halaman aktif
			itemsPerPage: 10,
		};
	},
	computed: {
		...mapGetters({
			user: 'user',
			isAdmin: 'isAdmin',
			isRoleAdmin: 'isRoleAdmin',
			isRoleSuperAdmin: 'isRoleSuperAdmin',
			isUserCan: 'isUserCan',
			productsColumns: 'productsColumns',
		}),
		productPreviewTarget() {
			let targetPath = '';

			if (this.saleCategory === 'catalog') {
				targetPath = '/admin/products/preview/';
			} else if (this.saleCategory === 'wholesale') {
				targetPath = '/admin/products/wholesale/preview/';
			}

			return targetPath;
		},
		showCatalogDetail() {
			return this.isShowDetail && this.saleCategory === 'catalog';
		},
		showWholesaleDetail() {
			return this.isShowDetail && this.saleCategory === 'wholesale';
		},
		categorizedColumns() {
			return groupBy(this.allProductsColumns, 'category');
		},
		columnsQuery() {
			return this.$route.query.columns;
		},
		// Hitung total halaman berdasarkan panjang data dan item per halaman
		totalPages() {
			if (this.wholesaleVisibility === 'private') {
				return Math.ceil(this.userWholesale.length / 10);
			}
			return Math.ceil(this.totalUserFeat / 10);
		},
		// Ambil data yang ditampilkan berdasarkan halaman aktif
		paginatedData() {
			if (this.isWholesale) {
				return this.userWholesale;
			}
			return this.SellerOnProducts;
		},
		columns() {
			const columnsArray = this.columnsQuery
				? this.columnsQuery.split(',')
				: this.productsColumns;

			return this.checkColumns(columnsArray);
		},
		selectAll: {
			get() {
				return this.products ? this.selectedProducts.length === this.products.length : false;
			},
			set(value) {
				const selected = [];
				if (value) {
					this.products.forEach((product) => {
						if (this.deleted === 'all') {
							if (!product.is_deleted) {
								selected.push(product._id);
							}
						} else {
							selected.push(product._id);
						}
					});
				}
				this.selectedProducts = selected;
			},
		},
		isSaleCategoryDistributor() {
			return this.saleCategory === 'wholesale';
		},
		params() {
			const urlParams = new URLSearchParams(window.location.search);
			const productId = urlParams.get('product_id');

			const params = {
				limit: this.limit,
				sort_by: this.sort_by,
				sort: this.sort,
				page: this.page,
			};

			if (productId) {
				params.product_id = productId;
			}

			if (this.selectedSupplier.length > 0) {
				const suppliers = this.selectedSupplier.map(el => el._id);
				params.supplier_ids = JSON.stringify(suppliers);
			}

			if (this.userId) {
				params.user_id = this.userId;
			}

			if (this.deleted && this.deleted === '1') {
				params.is_deleted = true;
			} else if (this.deleted && this.deleted === '0') {
				params.is_deleted = false;
			}

			if (this.landingPage && this.landingPage === '1') {
				params.is_landing_page_null = true;
			} else if (this.landingPage && this.landingPage === '0') {
				params.is_landing_page_null = false;
			}

			if (this.marketingKit && this.marketingKit === '1') {
				params.is_marketing_kit_null = true;
			} else if (this.marketingKit && this.marketingKit === '0') {
				params.is_marketing_kit_null = false;
			}

			if (this.productName) {
				params.name = this.productName;
			}

			if (this.saleCategory === 'wholesale') {
				params.sale_category = this.saleCategory;
			}

			if (this.status !== '') {
				let status = this.status;
				if (status === 'updated') {
					status = 'request';
					params.is_verified = true;
				} else if (status === 'out_of_stock') {
					status = 'all';
					params.is_out_of_stock = true;
				}
				params.status = status;
			}

			if (this.status !== '') {
				params.visibility = this.visibility;
			}

			if (this.keyword && this.keyword !== '') {
				params.keyword = this.keyword;
			}

			if (this.filterDateType) {
				params.filter_date_type = this.filterDateType;
			}

			if (this.since) {
				params.since = this.since;
			}

			if (this.until) {
				params.until = this.until;
			}

			if (this.blacklistedSellers.length > 0) {
				const blacklistedSellerIds = this.blacklistedSellers.map(seller => seller?.user_id);
				params.blacklisted_seller_ids = blacklistedSellerIds.join(',');
			}

			if (this.selectedTag !== 'all') {
				params.tag = this.selectedTag;
			}

			return params;
		},
		isDistributorErrorOnApprove() {
			return this.distributorErrors.length > 0 && this.changeStatusValue === 'live';
		},
		isCanDeleteProduct() {
			return this.isUserCan('product_delete');
		},
		isCanAddProduct() {
			return (this.isRoleAdmin || this.isRoleSuperAdmin) && this.isUserCan('admin_product_add');
		},
		isCanEditProduct() {
			return (this.isRoleAdmin || this.isRoleSuperAdmin) && this.isUserCan('admin_product_edit');
		},
		selectedProductsData() {
			const filter = (product) => {
				const isSelected = this.selectedProducts.find(selected => selected === product._id);
				return isSelected;
			};
			const products = this.products.filter(filter);
			return products;
		},
		supplierOptions() {
			const options = duplicateVar(this.suppliers);
			// const empty = {
			// 	_id: 'all',
			// 	name: 'All',
			// };
			// options.unshift(empty);
			return options;
		},
		timezone() {
			return this.user ? this.user.timezone : 'Asia/Jakarta';
		},
		statusParam() {
			return this.$route.query.status;
		},
		isFilterOn() {
			return this.status !== 'all'
				|| this.userId !== ''
				|| this.deleted !== '0'
				|| this.productName !== ''
				|| this.selectedSupplier.length > 0
				|| this.blacklistedSellers.length > 0
				|| this.visibility !== 'all'
				|| this.landingPage !== 'all'
				|| this.filterDateType !== null
				|| this.marketingKit !== 'all'
				|| this.selectedTag !== 'all';
		},
		isExpandEnabled() {
			const isEnabled = this.isShowColumn('variations') || this.isShowColumn('price') || this.isShowColumn('commision')
							|| this.isShowColumn('margin') || this.isShowColumn('recommended_price') || this.isShowColumn('stock');

			return isEnabled;
		},
		productTimelineFilterLabel() {
			let label = 'All Update';

			if (this.productTimelineFilter && this.productTimelineStatics[this.productTimelineFilter]) {
				label = this.productTimelineStatics[this.productTimelineFilter].label ?? 'All Update';
			}

			return label;
		},
	},
	watch: {
		'$route.query': {
			handler() {
				this.checkParams();
				this.fetchProducts(true);
			},
		},
		statusOverview() {
			if (this.statusOverview === 'pricing') {
				this.nextStatus = 'recontent';
				this.nextParam = this.nextStatus;
				this.nextVerified = false;
			} else if (this.statusOverview === 'recontent') {
				this.nextStatus = 'landing page';
				this.nextParam = 'landing_page';
				this.nextVerified = false;
			} else if (this.statusOverview === 'landing_page') {
				this.nextStatus = 'verification';
				this.nextParam = 'request';
				this.nextVerified = false;
			} else if (this.statusOverview === 'verification') {
				this.nextStatus = 'updated';
				this.nextParam = 'request';
				this.nextVerified = true;
			} else if (this.statusOverview === 'updated') {
				this.nextStatus = 'live';
				this.nextParam = 'live';
				this.nextVerified = false;
			} else {
				this.nextStatus = '';
			}
		},
		user(value) {
			if (value) {
				this.initColumns();
			}
		},
	},
	created() {
		// On Scroll Bottom
		window.addEventListener('scroll', this.handleScroll);
		this.checkParams();
		this.fetchProducts(true);
		this.fetchSuppliers();
		this.fetchStats();
		this.initColumns();
		this.getUserCountFeature();
	},
	destroyed() {
		window.removeEventListener('scroll', this.handleScroll);
	},
	methods: {
		...mapActions({
			delete: 'products/delete',
			fetchUser: 'fetchUser',
		}),
		isDangerousGoods(product) {
			const tags = product?.tags ?? [];
			const dangerousGoodsExists = tags.find(tag => tag.type === 'dangerous_goods');
			return dangerousGoodsExists;
		},
		changePage(page) {
			if (page >= 1 && page <= this.totalPages) {
				this.currentPage = page;
			}
			this.getUserActiveWholesale();
		},
		dangerousGoodsLabel(product) {
			return this.isDangerousGoods(product) ? 'Unmark' : 'Mark';
		},
		checkProductBadge(product, key = 'cod') {
			const badges = getProductBadges(product);
			return badges[key] ?? false;
		},
		openModalDangerousGoods(product) {
			this.selectedProduct = product;
			this.dangerousGoodsAction = this.dangerousGoodsLabel(this.selectedProduct);
			this.isShowModalDangerousGoods = true;
		},
		markAsDangerousGoods() {
			this.isSavingMarkAsDangerousGoods = true;

			const productId = this.selectedProduct?._id?.$oid ?? this.selectedProduct?._id;
			const isDangerousGoods = this.isDangerousGoods(this.selectedProduct);
			const mark = isDangerousGoods ? 0 : 1;
			const action = this.dangerousGoodsAction;
			const params = {
				dangerous_goods_mark: mark,
			};

			const callback = (response) => {
				const message = response?.message?.message ?? ''; // message from oo response
				const product = response?.data ?? {};

				if (product) {
					this.updateSelectedProductInList(product);
				}

				this.$notify({
					group: 'products',
					title: `${action} As Dangerous Goods`,
					text: message || 'Success',
					type: 'success',
				});

				this.isSavingMarkAsDangerousGoods = false;
				this.isShowModalDangerousGoods = false;
			};

			const errorCallback = (e) => {
				const msg = getAxiosErrorMessage(e);

				this.$notify({
					group: 'products',
					title: `${action} As Dangerous Goods`,
					text: msg || 'Something went wrong',
					type: 'error',
				});

				this.isSavingMarkAsDangerousGoods = false;
			};

			adminApi.updateProduct(productId, params, callback, errorCallback);
		},
		closeModalBulkUpdateBlacklistedSellers() {
			this.blacklistedSellers = [];
			this.isShowModalBulkUpdateBlacklistedSellers = false;
		},
		showModalBulkUpdateBlacklistedSellers() {
			this.blacklistedSellers = [];
			this.isShowModalBulkUpdateBlacklistedSellers = true;
		},
		showModalBulkUpdateHandlingFee() {
			this.isBulkUpdateHandlingFee = true;
			this.$refs.bulkHandlingFeeModal.show();
		},
		handleBulkCommissionSuccess() {
			// console.log('Bulk commission update successful', data);
			this.isShowBulkCommissionModal = false;
			this.fetchProducts(true);
			this.resetSelectedProducts();
		},
		submitBulkUpdateBlacklistedSellers() {
			this.isBulkUpdateBlacklistedSellers = true;

			const params = {
				selected_product_ids: this.selectedProducts.join(','),
				blacklisted_sellers: JSON.stringify(this.blacklistedSellers),
			};

			const callback = (response) => {
				const message = response?.message ?? '';
				const products = response?.data ?? [];

				if (products?.length > 0) {
					products.forEach(product => this.updateSelectedProductInList(product));
				}

				this.$notify({
					group: 'products',
					title: 'Bulk Update Blacklisted Sellers',
					text: message || 'Success',
					type: 'success',
				});

				this.isShowModalBulkUpdateBlacklistedSellers = false;
				this.isBulkUpdateBlacklistedSellers = false;
			};

			const errorCallback = (e) => {
				const msg = getAxiosErrorMessage(e);

				this.$notify({
					group: 'products',
					title: 'Bulk Update Blacklisted Sellers',
					text: msg || 'Something went wrong',
					type: 'error',
				});

				this.isBulkUpdateBlacklistedSellers = false;
			};

			bulkUpdateBlacklistedSellers(params, callback, errorCallback);
		},
		getProductSourcingFee(product, format = true) {
			const psfConfig = product?.product_sourcing_fee ?? defaultProductSourcingFeeConfig;
			const psfValue = psfConfig?.value ?? defaultProductSourcingFeeConfig?.value;
			return format ? `${psfValue}%` : psfValue;
		},
		getHandlingFee(product, format = true) {
			const hfConfig = product?.handling_fee ?? { type: 'per_order', feeSupplier: 0, marginPlatform: 0 };
			const feeSupplier = hfConfig?.feeSupplier ?? 0;
			const marginPlatform = hfConfig?.marginPlatform ?? 0;
			const hfType = hfConfig?.type ?? 'per_order';

			if (format) {
				const total = feeSupplier + marginPlatform;
				const typeLabel = hfType === 'per_order' ? 'order' : 'sku';

				// Format: Supplier (3000) + Platform (2000) = 5000/order
				const supplierStr = formatMoney(feeSupplier);
				const platformStr = formatMoney(marginPlatform);
				const totalStr = formatMoney(total);

				return `${supplierStr} + ${platformStr} = ${totalStr}/${typeLabel}`;
			}

			return feeSupplier + marginPlatform;
		},
		isProductLive(product) {
			return product.status === 'live';
		},
		previewLink(product) {
			let encodedId = btoa(product.user_id);

			if (this.saleCategory === 'catalog') {
				encodedId = btoa(product.user_id);
			} else if (this.saleCategory === 'wholesale') {
				encodedId = btoa(product._id);
			}

			return `${product.slug}-${encodedId}`;
		},
		excludeTableKey(data, keyToExclude) {
			const excludedData = duplicateVar(data);
			const keys = Object.keys(excludedData);
			if (keys.includes(keyToExclude)) {
				delete data[keyToExclude];
			}
			return excludedData;
		},
		filterProps(key) {
			return key !== 'price_updated';
		},
		changeSaleCategory(value) {
			this.saleCategory = value;
			this.fetchProducts(true);
		},
		isHaveChangelogs(product) {
			return product?.change_logs?.length ?? 0;
		},
		initColumns() {
			this.selectedColumns = duplicateVar(this.columns);
		},
		isShowColumn(key) {
			return this.columns.includes(key);
		},
		showCompareLog(product) {
			console.log(product);
			if (product.is_has_history) {
				this.isShowCompareLogModal = true;
				this.selectedProduct = product;

				const callback = (response) => {
					this.currentLog = response?.data?.product;
				};

				const errorCallback = (response) => {
					console.log(response);
				};

				adminApi.getProductHistoryLog(this.selectedProduct._id, callback, errorCallback);
			}
		},
		applyColumns() {
			const columns = duplicateVar(this.selectedColumns);
			const columnsString = columns.join(',');
			const query = duplicateVar(this.$route.query);
			query.columns = columnsString;
			this.$router.push({ name: 'adminProducts', query });
			this.isShowCustomColumns = false;
			const callback = () => this.fetchUser();
			const errorCallback = (data) => {
				this.$notify({
					group: 'app',
					title: 'Customize Column',
					text: data.message ?? 'Failed to Customize Column',
					type: 'error',
				});
			};

			userApi.updateProductsColumns(columns, callback, errorCallback);
		},
		resetColumns() {
			this.initColumns();
			this.isShowCustomColumns = false;
		},
		checkColumns(columns) {
			const productName = 'product';
			if (!columns.includes(productName)) {
				columns.push(productName);
			}

			return columns;
		},
		checkParams() {
			if (this.statusParam) {
				this.status = this.statusParam;
			}
		},
		fetchProducts(reset = true) {
			if (reset) {
				this.resetProducts();
			}

			this.isFetching = true;
			const params = this.params;

			const callback = (response) => {
				const products = response.data;
				this.products = this.products.concat(products);
				this.isAll = products.length < this.limit;
				this.page++;
				this.isFetching = false;
				this.isShowFilter = false;
			};
			const errorCallback = (e) => {
				const msg = getAxiosErrorMessage(e);
				// eslint-disable-next-line
				console.log(msg);
			};
			adminApi.getProducts(params, callback, errorCallback);
		},
		resetProducts() {
			this.products = [];
			this.isAll = false;
			this.page = 1;
		},
		resetSelectedProducts() {
			this.selectedProducts = [];
		},
		onKeywordChange() {
			const self = this;
			this.ooDelay(() => {
				self.fetchProducts();
			}, 1000);
		},
		handleScroll() {
			const pageHeight = document.documentElement.offsetHeight;
			const windowHeight = window.innerHeight;
			const scrollPosition = window.scrollY;
			const offset = 50;
			const isOnBottom = pageHeight - offset <= windowHeight + scrollPosition;
			if (isOnBottom) {
				if (!this.isFetching && !this.isAll) {
					this.fetchProducts(false);
				}
			}
		},
		changeSorting(key) {
			const isSame = this.sort_by === key;
			this.sort_by = key;
			const sort = isSame && this.sort === 'asc' ? 'desc' : 'asc';
			this.sort = sort;
			// Re-fetch
			this.fetchProducts(true);
		},
		sortClass(key) {
			const sameKey = this.sort_by === key;
			const className = sameKey ? `th-sort-${this.sort}` : '';
			return className;
		},
		formatNumber(number) {
			return formatNumber(number, 0, ',', '.');
		},
		applyFilter() {
			if (this.dateType !== '') {
				this.filterDateType = this.dateType;
			}
			this.fetchProducts(true);
		},
		resetFilter() {
			this.userId = '';
			this.status = 'all';
			this.deleted = '0';
			this.productName = '';
			this.selectedSupplier = [];
			this.blacklistedSellers = [];
			this.visibility = 'all';
			this.landingPage = 'all';
			this.marketingKit = 'all';
			this.selectedTag = 'all';
			this.filterDateType = null;
			this.dateType = null;
			this.since = null;
			this.until = null;
		},
		clearFilter() {
			if (Object.keys(this.$route.query).length > 0) {
				this.resetFilter();
				this.$router.replace({ query: null });
			} else {
				this.resetFilter();
				this.applyFilter();
			}
		},
		formatDate(dateString) {
			const format = 'DD-MM-YYYY - HH:mm';
			const timezone = this.user.timezone;
			// const formattedDate = this.moment.utc(dateString).local().format(format);
			const formattedDate = this.moment
				.utc(dateString)
				.tz(timezone)
				.format(format);
			return dateString && dateString !== '' ? formattedDate : '';
		},
		restore(product) {
			this.selectedProduct = product;
			this.isShowConfirmRestore = true;
		},
		doRestore() {
			this.isRestoring = true;
			const id = this.selectedProduct._id;
			const callback = (response) => {
				const message = response.message;
				this.isRestoring = false;
				// update status
				const productIndex = this.products.findIndex(curr => curr._id === id);
				if (productIndex !== -1) {
					this.products[productIndex].is_deleted = false;
					this.products[productIndex].deleted_by = null;
					this.products[productIndex].deleted_by_name = null;
					this.products[productIndex].deleted_at = null;
				}
				this.selectedProduct = null;
				this.isShowConfirmRestore = false;

				this.$notify({
					group: 'products',
					title: 'Product',
					text: message,
					type: 'success',
				});
			};
			const errorCallback = (e) => {
				const msg = getAxiosErrorMessage(e);
				// eslint-disable-next-line
				console.log(msg);
			};
			adminApi.restoreProduct(id, callback, errorCallback);
		},
		getDistributorWholesaleLength(product) {
			const wholesale = this.getDistributorWholesale(product);
			return wholesale?.length;
		},
		getDistributorWholesale(product) {
			return product?.distributor?.wholesale ?? [];
		},
		getDistributorStatus(product) {
			return product?.distributor?.enabled ?? false;
		},
		getDistributorPrice(product, format = true) {
			if (!this.getDistributorStatus(product)) {
				return '-';
			}
			const price = product?.distributor?.price ?? null;
			return format ? formatMoney(price) : price;
		},
		getDistributorSlashPrice(product, format = true) {
			if (!this.getDistributorStatus(product)) {
				return '-';
			}
			const price = product?.distributor?.slash_price ?? null;
			return format ? formatMoney(price) : price;
		},
		getDistributorStock(product) {
			if (!this.getDistributorStatus(product)) {
				return '-';
			}
			return product?.distributor?.stock?.quantity ?? 0;
		},
		pricing(product) {
			const payload = {
				message: 'Are you sure want to change status to Pricing for product',
				status: 'pricing',
			};
			this.setModalChangeStatus(product, payload);
		},
		recontent(product) {
			const payload = {
				message: 'Are you sure want to change status to Marketing Kit for product',
				status: 'recontent',
			};
			this.setModalChangeStatus(product, payload);
		},
		setLandingPageStatus(product) {
			const payload = {
				message: 'Are you sure want to change status to Landing Page for product',
				status: 'landing_page',
			};
			this.setModalChangeStatus(product, payload);
		},
		verification(product) {
			const payload = {
				message: 'Are you sure want to change status to Verification for product',
				status: 'request',
			};
			this.setModalChangeStatus(product, payload);
		},
		approve(product) {
			const payload = {
				message: 'Are you sure want to approve product',
				status: 'live',
			};
			this.setModalChangeStatus(product, payload);
		},
		archive(product) {
			const payload = {
				message: 'Are you sure want to archive product',
				status: 'disabled',
			};
			this.setModalChangeStatus(product, payload);
		},
		reject(product) {
			const payload = {
				message: 'Are you sure want to reject product',
				status: 'reject',
			};
			this.setModalChangeStatus(product, payload);
		},
		rejectUpdate(product) {
			const payload = {
				message: 'Are you sure want to reject update from this product',
				status: 'reject_updated',
			};
			this.setModalChangeStatus(product, payload);
		},
		undo(product) {
			const payload = {
				message: 'Are you sure want to undo status to request product',
				status: 'request',
			};
			this.setModalChangeStatus(product, payload);
		},
		suspend(product) {
			const payload = {
				message: 'Are you sure want to suspend product',
				status: 'suspended',
			};
			this.setModalChangeStatus(product, payload);
		},
		unsuspend(product) {
			const payload = {
				message: 'Are you sure want to unsuspend product and set status to active',
				status: 'live',
			};
			this.previousStatus = product?.previous_status ?? null;
			this.setModalChangeStatus(product, payload);
		},
		setModalChangeStatus(product, payload) {
			this.selectedProduct = product;
			this.messageConfirmChangeStatus = payload.message;
			this.isShowConfirmChangeStatus = true;
			this.changeStatusValue = payload.status;
			this.suspendNoteValidation = null;

			if (this.changeStatusValue === 'live') {
				this.distributorErrors = [];
				this.validateDistributor(product);
			}
		},
		doChangeStatus() {
			this.isChangeStatus = true;
			const id = this.selectedProduct._id;

			const params = {
				status: (this.previousStatus !== null) ? this.previousStatus : this.changeStatusValue,
			};

			const callback = (response) => {
				const data = response.data;
				const message = response.message;
				this.isChangeStatus = false;
				// update status
				const productIndex = this.products.findIndex(curr => curr._id === id);
				if (productIndex !== -1) {
					if (this.changeStatusValue === 'reject_updated') {
						this.products[productIndex].name = data.product.name;
						this.products[productIndex].status = data.product.status;
						this.products[productIndex].status_number = data.product.status_number;
						this.products[productIndex].price = data.product.price;
						this.products[productIndex].commision_percentage = data.product.commision_percentage;
						this.products[productIndex].stock.quantity = data.product.stock.quantity;
						this.products[productIndex].change_logs = [];
						this.products[productIndex].timestamps = this.updateTimestamps(params.status, data.status, this.products[productIndex].timestamps, this.products[productIndex].is_verified);
					} else {
						this.products[productIndex].status = data.status;
						this.products[productIndex].change_logs = [];
						this.products[productIndex].suspend_note = data.suspend_note;
						this.products[productIndex].timestamps = this.updateTimestamps(params.status, data.status, this.products[productIndex].timestamps, this.products[productIndex].is_verified);
					}
				}
				this.selectedProduct = null;
				this.isShowConfirmChangeStatus = false;
				this.changeStatusValue = '';
				this.suspendNote = '';
				this.previousStatus = null;

				this.$notify({
					group: 'products',
					title: 'Product',
					text: message,
					type: 'success',
				});
			};
			const errorCallback = (e) => {
				const msg = getAxiosErrorMessage(e);
				// eslint-disable-next-line
				console.log(msg);
			};

			if (this.changeStatusValue === 'suspended') {
				params.suspend_note = this.suspendNote;
				if (params.suspend_note !== '') {
					this.suspendNoteValidation = '';
					adminApi.updateStatusProduct(id, params, callback, errorCallback);
				} else {
					this.suspendNoteValidation = "Suspend Note can't be empty";
					this.isChangeStatus = false;
				}
			} else {
				adminApi.updateStatusProduct(id, params, callback, errorCallback);
			}
		},
		validateDistributor(product) {
			const distributor = product?.distributor ?? {};
			// check if distributor enabled
			const isDistributorEnabled = distributor?.enabled ?? false;
			if (isDistributorEnabled) {
				// check value of distributor price
				const distributorPrice = distributor?.price ?? 0;
				if (distributorPrice <= 0) {
					this.distributorErrors.push('Harga HPP Wholesale tidak valid');
				}

				// check value of distributor slash price
				const distributorSlashPrice = distributor?.slash_price ?? 0;
				if (distributorSlashPrice <= 0) {
					this.distributorErrors.push('Harga Coret tidak valid');
				} else if (distributorSlashPrice <= distributorPrice) {
					this.distributorErrors.push(`Harga Coret harus lebih besar dari Harga HPP Wholesale ${formatMoney(distributorPrice)}`);
				}

				// check value of distributor wholesale price
				const distributorWholesale = distributor?.wholesale ?? [];
				const errors = validateDistributorWholesale(distributorWholesale);
				if (distributorWholesale?.length <= 0) {
					this.distributorErrors.push('Harga Wholesale tidak valid');
				} else if (errors.min.length > 0
					|| errors.max.length > 0
					|| errors.discount.length > 0
					|| errors.price.length > 0) {
					const errorsMin = errors.min.flat();
					const errorsMax = errors.max.flat();
					const errorsDiscount = errors.discount.flat();
					const errorsPrice = errors.price.flat();

					const errorsWholesale = [
						...errorsMin,
						...errorsMax,
						...errorsDiscount,
						...errorsPrice,
					];

					this.distributorErrors = [
						...this.distributorErrors,
						...new Set(errorsWholesale),
					];
				}
			}
		},
		getStockQuantity(product) {
			const isSimple = product.type === 'simple';
			const quantity = isSimple ? product.stock.quantity : product.variations.prices.reduce((prevQty, variation) => {
				const variationQuantity = variation.stock ? variation.stock.quantity : 0;
				const totalQuantity = prevQty + variationQuantity;
				return totalQuantity;
			}, 0);
			return quantity;
		},
		getVariantStockQuantity(variant) {
			const variantQuantity = variant?.stock?.quantity ?? '-';

			return variantQuantity;
		},
		getProductDisplayStatus,
		getProductVisibilityStatus,
		bulkDelete() {
			this.isDeleting = true;
			const callback = () => {
				this.isDeleting = false;
				for (let i = 0; i < this.selectedProducts.length; i++) {
					const id = this.selectedProducts[i];
					const index = this.products.findIndex(product => product._id === id);
					const isIndex = index !== -1;
					if (isIndex) {
						// this.delete(index);
						this.fetchProducts(true);
					}
				}
				this.$set(this, 'selectedProducts', []);

				this.isShowDeleteProductBulk = false;
				this.$notify({
					group: 'products',
					title: 'Products',
					text: 'Products deleted',
					type: 'success',
				});
			};
			adminApi.bulkDeleteProduct(this.selectedProducts.slice(), callback);
		},
		isShowModalBulk() {
			const modalType = this.nextStatus;
			this.modalBulkTitle = modalType;
			this.isShowModalBulkStatus = true;
		},
		performBulkAction(status, modalType, successMessage, isVerification) {
			this.bulkLoading = true;
			const callback = () => {
				this.bulkLoading = false;
				for (let i = 0; i < this.selectedProducts.length; i++) {
					const id = this.selectedProducts[i];
					const index = this.products.findIndex(product => product._id === id);
					const isIndex = index !== -1;
					if (isIndex) {
						this.fetchProducts(true);
					}
				}
				this.$set(this, 'selectedProducts', []);

				this.isShowModalBulkStatus = false;
				this.$notify({
					group: 'products',
					title: modalType,
					text: successMessage,
					type: 'success',
				});
				this.fetchStats();
			};
			adminApi.bulkUpdateStatusProduct(this.selectedProducts.slice(), status, isVerification, callback);
		},
		deleteProduct() {
			this.isDeleting = true;
			const callback = () => {
				this.isDeleting = false;
				const id = this.selectedProduct._id;
				const index = this.products.findIndex(product => product._id === id);
				const isIndex = index !== -1;
				if (isIndex) {
					// this.delete(index);
					this.fetchProducts(true);
				}
				this.$set(this, 'selectedProduct', null);

				this.isShowDeleteProduct = false;
				this.$notify({
					group: 'products',
					title: 'Products',
					text: 'Product deleted',
					type: 'success',
				});
			};
			adminApi.bulkDeleteProduct([this.selectedProduct._id], callback);
		},
		showConfirmDeleteProduct(product) {
			this.selectedProduct = product;
			this.isShowDeleteProduct = true;
		},
		showConfirmDuplicateProduct(product) {
			this.selectedProduct = product;
			this.isShowDuplicateProduct = true;
		},
		bulkRestore() {
			this.isDeleting = true;
			const callback = () => {
				this.isDeleting = false;
				for (let i = 0; i < this.selectedProducts.length; i++) {
					const id = this.selectedProducts[i];
					const index = this.products.findIndex(product => product._id === id);
					const isIndex = index !== -1;
					if (isIndex) {
						// this.delete(index);
						this.fetchProducts(true);
					}
				}
				this.$set(this, 'selectedProducts', []);

				this.isShowConfirmRestoreBulk = false;
				this.$notify({
					group: 'products',
					title: 'Products',
					text: 'Products restored',
					type: 'success',
				});
			};
			adminApi.bulkRestoreProduct(this.selectedProducts.slice(), callback);
		},
		fetchSuppliers() {
			const params = {
				limit: 2000,
				sort_by: 'created_at',
				sort: 'desc',
				page: 1,
				keyword: '',
				role: 'owner',
				owner_type: 'supplier', // supplier
			};

			const callback = (response) => {
				let suppliers = response.data;

				if (suppliers.length > 0) {
					suppliers = suppliers.map((data) => {
						const newObj = {};
						newObj._id = data._id;
						newObj.name = data.name;
						newObj.email = data.email;
						newObj.businessName = data.store?.name || '';
						newObj.code = data?.code || '';
						return newObj;
					});
				}

				this.suppliers = suppliers;
			};
			const errorCallback = (e) => {
				const msg = getAxiosErrorMessage(e);
				// eslint-disable-next-line
				console.log(msg);
			};
			userApi.getUsersMinimal(params, callback, errorCallback);
		},
		getUserActiveWholesale() {
			this.isFetchingListSeller = true;
			const params = {
				is_get_without_limit: true,
				sort_by: 'created_at',
				sort: 'desc',
				page: this.currentPage,
				keyword: '',
				role: 'owner',
				owner_type: 'dropshipper',
				feature: 'private_order',
			};

			const callback = (res) => {
				this.isFetchingListSeller = false;
				const users = res?.data ?? [];
				this.userWholesale = users;
			};

			const errorCallback = (e) => {
				this.isFetchingListSeller = false;
				console.log(e);
			};

			userApi.getUsersMinimal(params, callback, errorCallback);
		},
		getUserCountFeature() {
			const params = {};

			const callback = (res) => {
				const data = res?.data;
				this.totalUserFeat = data?.total ?? 0;
			};

			const err = (e) => {
				console.log(e);
			};

			getUserFeatCount('private_order', params, callback, err);
		},
		isPriceChange(product) {
			const price = getProductChangeLog(product, 'price');
			return price != null;
		},
		hasPriceChangeUpdated(product) {
			const price = getProductChangeLog(product, 'price_updated');
			// console.log(product.name, price);
			return price != null;
		},
		getProductChangeActiveDate(product) {
			const activeDate = getProductChangeLog(product, 'price', 'active_date');
			return activeDate != null ? formatDate(this.moment, activeDate) : null;
		},
		isProductChangeActiveDateThisDay(product) {
			const activeDate = getProductChangeLog(product, 'price', 'active_date');
			if (activeDate != null) {
				const now = this.moment().format('YYYY-MM-DD');
				const date = this.moment.utc(activeDate.date).tz(this.timezone);
				if (now >= date.format('YYYY-MM-DD')) {
					return true;
				}
			}
			return false;
		},
		getProductChangeLogs(product) {
			const changeLogs = product.change_logs;
			if (changeLogs === null || changeLogs === undefined) {
				return null;
			}

			const changeLogsFiltered = changeLogs.filter(x => x.data.key !== 'price_updated');
			if (changeLogsFiltered === null || changeLogsFiltered === undefined) {
				return null;
			}

			return changeLogsFiltered;
		},
		showProductDetail(product) {
			this.isGetDetail = true;
			this.selectedProduct = product;
			this.isShowDetail = true;
			const callback = (response) => {
				this.isGetDetail = false;
				this.selectedProduct = response.data;
			};
			const errorCallback = () => {
				this.isGetDetail = false;
			};
			const params = {
				product_id: this.selectedProduct._id,
				show_variation_table: true,
			};

			productApi.getProductDetails(params.product_id, callback, errorCallback, params);
		},
		sortClassTimeline(key) {
			const sameKey = this.timeline_sort_by === key;
			const className = sameKey ? `th-sort-${this.timeline_sort}` : '';
			return className;
		},
		changeSortingTimeline(key) {
			const isSame = this.timeline_sort_by === key;
			this.timeline_sort_by = key;
			const sort = isSame && this.timeline_sort === 'asc' ? 'desc' : 'asc';
			this.timeline_sort = sort;
			// Re-fetch
			this.fetchProductTimeline(true);
		},
		toggleModalProductTimeline(state = true) {
			this.isShowModalProductTimeline = state;
			if (!state) {
				this.selectedProductTimeline = {};
				this.timelineData = [];
				this.timeline_page = 1;
				this.isLoadMoreEnabled = true;
				this.productTimelineFilter = null;
			}
		},
		showProductTimeline(product) {
			this.selectedProductTimeline = {
				_id: product?._id?.$oid ?? product?._id,
				name: product?.name,
				supplier: this.getSupplierName(product),
				productImage: product.pictures && product.pictures.length > 0 ? product?.pictures[0] : 'https://cdn.ostock.id/img/default-product.png',
			};
			this.toggleModalProductTimeline(true);
			this.fetchProductTimeline();
		},
		fetchProductTimeline(reset = false) {
			this.isFetchingProductTimeline = true;
			if (reset) {
				this.timelineData = [];
			}

			const productId = this.selectedProductTimeline?._id;

			const params = {
				page: this.timeline_page,
				limit: 10,
				sort: this.timeline_sort,
				sort_by: this.timeline_sort_by,
			};

			if (this.productTimelineFilter && this.productTimelineFilter !== 'all') {
				params.key = this.productTimelineFilter;
			}

			const includeKeys = Object.keys(this.productTimelineStatics).length <= 1;

			if (includeKeys) {
				params.include_keys = 1;
			}

			const callback = (response) => {
				const responseData = response.data;

				if (includeKeys) {
					this.productTimelineStatics = {
						...this.productTimelineStatics,
						...responseData?.keys,
					};
				}

				const productTimelineList = responseData?.list;
				if (productTimelineList?.length <= 0) {
					this.isLoadMoreEnabled = false;
				} else {
					this.isLoadMoreEnabled = true;
				}
				productTimelineList.forEach((item) => {
					item.data.forEach((it) => {
						const data = {
							_id: item?._id?.$oid ?? item?._id,
							label: it.label,
							key: it.key,
							type: it.type,
							value_before: it.value_before,
							value_after: it.value_after,
							created_at: item.created_at,
							created_by: item.created_by_name,
						};

						if (this.excludedKeys.includes(it.key)) {
							return;
						}

						if (this.productTimelineFilter && this.productTimelineFilter !== 'all') {
							if (this.productTimelineFilter === it.key) {
								this.timelineData.push(data);
							}
						} else {
							this.timelineData.push(data);
						}
					});
				});

				this.isFetchingProductTimeline = false;
			};

			const errorCallback = (e) => {
				const msg = getAxiosErrorMessage(e);
				console.log(msg);

				this.isFetchingProductTimeline = false;
			};

			getProductTimeline(productId, params, callback, errorCallback);
		},
		exportProductTimeline() {
			this.isExporting = true;

			const productId = this.selectedProductTimeline?._id;

			const params = {
				sort: this.timeline_sort,
				sort_by: this.timeline_sort_by,
			};

			if (this.productTimelineFilter && this.productTimelineFilter !== 'all') {
				params.key = this.productTimelineFilter;
			}

			const callback = (response) => {
				const url = response.data;
				downloadFile(url);

				this.isExporting = false;
			};

			const errorCallback = (e) => {
				const msg = getAxiosErrorMessage(e);
				console.log(msg);

				this.isExporting = false;
			};

			exportProductTimeline(productId, params, callback, errorCallback);
		},
		assignProductTimelineFilter(key) {
			this.productTimelineFilter = key;
			this.timeline_page = 1;
			this.fetchProductTimeline(true);
		},
		loadMore() {
			this.timeline_page++;
			this.fetchProductTimeline();
		},
		getFinalPrice(product, format = true) {
			const price = getDropshipFinalPrice(product, [], 1, true, false);
			return format ? this.formatMoney(price) : price;
		},
		getVariantFinalPrice(product, index, format = true) {
			const variant = getDropshipVariationFinalPrice(product, false, true, false);
			const variantPrice = variant?.prices[index]?.price ?? '';
			return format ? this.formatMoney(variantPrice) : variantPrice;
		},
		showUpdateProduct(product, type) {
			this.updateType = type;
			this.selectedProduct = product;
			this.isShowUpdateModal = true;
		},
		updateSelectedProductInList(product) {
			const productIndex = this.products.findIndex(curr => curr._id === product._id);
			if (productIndex !== -1) {
				const selectedProduct = duplicateVar(this.products[productIndex]);
				delete product.timestamps;

				selectedProduct.commission_config = product.commission_config;

				const updatedProduct = {
					...selectedProduct,
					...product,
				};

				this.products[productIndex] = updatedProduct;
			}
		},
		getProductPrice(product) {
			const productPlusCommission = getProductPricePlusCommission(product);
			return formatMoney(productPlusCommission);
		},
		getProductVariantPrice(variant, product) {
			const productPlusCommission = getProductVariantPricePlusCommission(variant, product);
			return formatMoney(productPlusCommission);
		},
		getCommissionConfig(product) {
			const config = product?.commission_config;
			return {
				...duplicateVar(DEFAULT_COMMISSION_CONFIG),
				...(config || {}),
			};
		},
		formatCommissionSummary(product) {
			const config = this.getCommissionConfig(product);

			if (config.type === 'percentage') {
				const minLabel = typeof config.minimum_commission === 'number'
					? ` • min ${formatMoney(config.minimum_commission)}`
					: '';
				return `${config.value}%${minLabel}`;
			}
			return formatMoney(config.value);
		},
		getCommissionImpactLabel(product) {
			const config = this.getCommissionConfig(product);
			return config.impact === 'affect_selling_price'
				? 'Affects selling price'
				: 'Does not affect selling price';
		},
		openCommissionModal(product) {
			this.commissionModalProduct = product;
			this.isShowCommissionModal = true;
		},
		handleCommissionModalClose() {
			this.isShowCommissionModal = false;
			this.commissionModalProduct = null;
		},
		onCommissionUpdated(product) {
			if (product) {
				// console.log('product: ', product);
				// this.updateSelectedProductInList(product);
				const productIndex = this.products.findIndex(curr => curr._id === product._id);
				if (productIndex !== -1) {
					this.products[productIndex].commission_config = product.commission_config;
				}
			}
			this.handleCommissionModalClose();
		},
		getCommissionValueFormated,
		getVariantCommissionValueFormated,
		exportProducts() {
			this.isExporting = true;
			const params = this.params;
			const callback = (response) => {
				this.isExporting = false;
				const url = response.data;
				downloadFile(url);
			};
			const errorCallback = () => {
				this.isExporting = false;
			};

			adminApi.exportProducts(params, callback, errorCallback);
		},
		fetchStats() {
			this.isFetchingStatistic = true;
			const filteredStats = statItems.filter(item => item === 'products');

			const params = {
				items: filteredStats.join(','),
			};

			const callback = (response) => {
				this.stats = response.data;
				this.isFetchingStatistic = false;
			};

			const errorCallback = (e) => {
				console.log(e);
				this.isFetchingStatistic = false;
			};

			statsApi.getAdminProductsStats(params, callback, errorCallback);
		},
		supplierLabel({ name, businessName, code }) {
			return `${name} - ${businessName} - ${code}`;
		},
		overviewAction(key) {
			this.resetSelectedProducts();
			this.status = key;

			this.statusOverview = key;
			if (this.status === 'request' && !this.isVerified) {
				this.statusOverview = 'verification';
			}
			if (this.status === 'request' && this.isVerified) {
				this.statusOverview = 'updated';
			}
			this.applyFilter();
		},
		toTitleCase,
		jsonPretty,
		getSupplierName(product) {
			const supplierName = product.supplier_name ?? '-';
			const businessName = product.business_name ?? '';
			let supplier = supplierName;
			if (businessName) {
				supplier += ` - ${businessName}`;
			}
			return supplier;
		},
		showTimeStamps(timestamps) {
			const pricingAt = timestamps?.pricing_at ?? '-';
			const recontentAt = timestamps?.recontent_at ?? '-';
			const landingPageAt = timestamps?.landing_page_at ?? '-';
			const verifiedAt = timestamps?.verified_at ?? '-';
			const updatedAt = timestamps?.updated_at ?? '-';
			const liveAt = timestamps?.live_at ?? '-';
			const rejectedAt = timestamps?.rejected_at ?? '-';
			const disabledAt = timestamps?.disabled_at ?? '-';
			const suspendedAt = timestamps?.suspended_at ?? '-';

			const timestampsLabel = ['Pricing', 'Marketing Kit', 'Landing Page', 'Verified', 'Updated', 'Live', 'Rejected', 'Disabled', 'Suspended'];
			const timestampsArray = [pricingAt, recontentAt, landingPageAt, verifiedAt, updatedAt, liveAt, rejectedAt, disabledAt, suspendedAt];

			let date = '';
			timestampsArray.forEach((value, index) => {
				const type = `timestamps.${timestampsLabel[index].toLowerCase()}_at`;

				date += `
					<div class="timestamps-date ${this.filterDateType === type ? 'bg-highlight' : ''}">
						<div class="label-timestamps">
							${timestampsLabel[index]}:
						</div>
						<div class="value-timestamps">
							${formatDate(this.moment, value, 'DD-MM-YYYY HH:mm')}
						</div>
					</div>
				`;
			});

			return date;
		},
		getDateNow,
		updateTimestamps(changeStatus, status, timestampsDefault, isVerified) {
			const timestamps = timestampsDefault;

			switch (status || changeStatus) {
			case 'pricing':
				timestamps.pricing_at = this.getDateNow();
				break;
			case 'recontent':
				timestamps.recontent_at = this.getDateNow();
				break;
			case 'landing_page':
				timestamps.landing_page_at = this.getDateNow();
				break;
			case 'request':
				if (!isVerified) {
					timestamps.verified_at = this.getDateNow();
				} else {
					timestamps.updated_at = this.getDateNow();
				}
				break;
			case 'live':
				timestamps.live_at = this.getDateNow();
				break;
			case 'reject':
				timestamps.rejected_at = this.getDateNow();
				break;
			case 'reject_updated':
				timestamps.rejected_at = this.getDateNow();
				timestamps.live_at = this.getDateNow();
				break;
			case 'disabled':
				timestamps.disabled_at = this.getDateNow();
				break;
			case 'suspended':
				timestamps.suspended_at = this.getDateNow();
				break;
			default:
				break;
			}

			return timestamps;
		},

		isShowExpand(product) {
			const isShow = (product.type === 'variable' && this.isExpandEnabled) && (product.variations.prices.length > this.variationShownLimit);

			return isShow;
		},
		getBlacklistedSellerCount(product) {
			return product?.blacklisted_sellers?.length ?? 0;
		},
		getMaxQtyConfig(product, key = null) {
			const config = product?.max_qty ?? null;
			if (!key) {
				return config;
			}
			return config[key] ?? null;
		},
		toggleLabel(index) {
			let label = 'Tutup kumpulan variasi';
			const isExpanded = this.getProductVariationsExpandStatus(index);
			const variations = this.getProductVariations(index);

			const variationsCount = variations.length - this.variationShownLimit;
			if (!isExpanded) {
				label = `Lihat ${variationsCount} variasi lainnya`;
			}

			return label;
		},
		toggleExpandVariations(index) {
			const isExpanded = this.getProductVariationsExpandStatus(index);

			this.products[index].is_variations_expanded = !isExpanded;

			this.$forceUpdate();
		},
		getProductVariationsExpandStatus(index) {
			const isExpanded = this.products[index]?.is_variations_expanded ?? false;

			return isExpanded;
		},
		getProductVariations(index) {
			const variations = this.products[index]?.variations?.prices ?? [];

			return variations;
		},
		getSplicedProductVariations(index) {
			const variations = this.getProductVariations(index);
			const duplicatedVariations = duplicateVar(variations);

			const isExpanded = this.getProductVariationsExpandStatus(index);
			if (!isExpanded) {
				duplicatedVariations.splice(this.variationShownLimit);
			}

			return duplicatedVariations;
		},
		getVariationName(variation, position) {
			let variationName = '';
			const variationNameString = variation?.name ?? '';
			if (variationNameString) {
				const nameArray = variationNameString.split('||');

				variationName = nameArray[position] ?? '';
			}

			return variationName;
		},
		eachVariantHasCommission(index) {
			const variations = this.getProductVariations(index);
			const outsourceCommissions = variations.filter(variant => variant?.outsource_commission);
			const isHasAll = variations.length === outsourceCommissions.length;

			return isHasAll;
		},
		eachVariantHasMargin(index) {
			const variations = this.getProductVariations(index);
			const margins = variations.filter(variant => variant?.margin);
			const isHasAllMargin = variations.length === margins.length;

			return isHasAllMargin;
		},
		getVariationTooltip(variation, position) {
			const variationName = this.getVariationName(variation, position);

			let tooltip = '';
			if (variationName.length > 20) {
				tooltip = variationName;
			}

			return tooltip;
		},
		cutText(text, maxLength = 20) {
			if (text.length <= maxLength) {
				return text;
			}

			return `${text.slice(0, maxLength - 3)}...`;
		},
		getDisplayedVariationName(variation, position) {
			const variationName = this.getVariationName(variation, position);

			return this.cutText(duplicateVar(variationName));
		},
		columnSpacing(product, idx) {
			const lastItemCollapsed = !product?.is_variations_expanded && idx === (this.variationShownLimit - 1);
			const lastItemExpanded = product?.is_variations_expanded && idx === (product?.variations?.prices?.length - 1);
			const notLastItemCollapsed = !product?.is_variations_expanded && idx !== (this.variationShownLimit - 1);
			const notLastItemExpanded = product?.is_variations_expanded && idx !== (product?.variations?.prices?.length - 1);

			return {
				'mb-0': lastItemCollapsed || lastItemExpanded,
				'mb-4': notLastItemCollapsed || notLastItemExpanded,
			};
		},
		fetchListSeller(productId) {
			this.isFetchingListSeller = true;
			this.SellerOnProducts = [];
			const params = {
				product_id: productId,
			};

			const callback = (response) => {
				const sellers = response.data;
				this.SellerOnProducts = sellers;
				this.isFetchingListSeller = false;
			};
			const errorCallback = () => {
				this.$notify({
					group: 'app',
					title: 'Fetching List Seller On Product',
					text: 'There is something wrong when fetching proccess',
					type: 'error',
				});
				this.isFetchingListSeller = false;
			};
			adminApi.listSellerOnProduct(params, callback, errorCallback);
		},
		onShowSeller(productId, isWholesale = false, visibility = 'public') {
			this.SellerOnProducts = [];
			this.isShowListSeller = true;
			this.currentPage = 1;
			if (isWholesale) {
				if (visibility === 'private') {
					this.userWholesale = productId;
				} else {
					this.getUserActiveWholesale();
				}
				this.isWholesale = isWholesale;
				this.wholesaleVisibility = visibility;
			} else {
				this.fetchListSeller(productId);
				this.isWholesale = false;
			}
		},
		duplicateProduct(productId) {
			this.isDuplicatingProduct = true;
			const callback = (response) => {
				// this.products.push(response.data);
				const message = response.message;
				this.isDuplicatingProduct = false;
				this.isShowDuplicateProduct = false;
				this.$notify({
					group: 'products',
					title: 'Product',
					text: message,
					type: 'success',
				});

				this.fetchStats();
				this.fetchProducts();
			};
			const errorCallback = (e) => {
				// eslint-disable-next-line
				console.log(e);
				const message = e.response.data.message;
				this.isDuplicatingProduct = false;
				this.isShowDuplicateProduct = false;
				this.$notify({
					group: 'products',
					title: 'Product',
					text: message,
					type: 'error',
				});
			};

			productApi.duplicate(productId, callback, errorCallback);
		},
	},
};
</script>
<style lang="scss" scoped>
.product-status {
	font-weight: 700;
	font-size: .85em;

	&.active {
		.material-icons {
			font-size: 12px;
			color: #28a745;
		}
		color: #28a745;
	}

	&.deleted {
		.material-icons {
			font-size: 12px;
			color: #ff1744;
		}
		color: #ff1744;
	}
}
.mh-20 {
	// height: 40rem;
	overflow: visible !important;
}

.commission-config-summary {
	font-size: .85em;
	line-height: 1.4;
	margin-bottom: 0.5rem;

	.commission-config-primary {
		font-weight: 600;
	}

	.commission-config-impact {
		font-size: 0.75em;
		color: #6c757d;
	}
}

.changes-style {
	background-color: #00c73917;
	color: green;
	padding: 0.5rem;
}

.changes-style-current {
	background-color: #c7000017;
	color: red;
	padding: 0.5rem;
}
.body-log-modal {
    max-height: 33rem;
    overflow-y: auto;
}

.row {
    display: flex;
}

.col-md-6 {
    flex: 1;
    display: flex;
    flex-direction: column;
}

.timestamps-date {
	min-width: 180px;
}
.w-128 {
	width: 128px;
	min-width: 128px;
}

.w-150 {
	width: 150px;
	min-width: 150px;
}

.w-180 {
	width: 180px;
	min-width: 180px;
}

.w-200 {
	width: 200px;
	min-width: 200px;
}

.w-250 {
	width: 250px;
	min-width: 250px;
}

.w-300 {
	width: 300px;
	min-width: 300px;
}

.h-50 {
	min-height: 50px;
	max-height: 50px;
}

.line {
	flex: 1;
	border-bottom: 1px solid #006DC7;
	margin: 10px 0;
}

.variation-status {
	font-size: 14px;
	margin-top: 5px !important;
}

.table-wholesale td {
	padding: 0 5px 0 5px;
	border: 1px solid black;
	border-collapse: collapse;
}
</style>
